var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 630,
    height: 310,
    viewBox: "0 0 630 310",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M349.926 156.291C349.983 156.291 350.039 156.291 350.099 156.281L350.178 156.271C350.997 156.176 351.584 155.425 351.491 154.594C351.398 153.762 350.656 153.166 349.84 153.26L349.761 153.27C348.942 153.364 348.355 154.115 348.448 154.947C348.534 155.722 349.18 156.291 349.926 156.291Z",
    fill: "#5B8AEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M571.41 269.449C571.626 269.449 571.844 269.402 572.053 269.301C572.796 268.94 573.111 268.034 572.753 267.28L572.68 267.122C572.322 266.367 571.43 266.051 570.687 266.415C569.944 266.778 569.633 267.684 569.991 268.438L570.061 268.587C570.316 269.129 570.85 269.449 571.407 269.449H571.41ZM568.038 262.623C568.27 262.623 568.502 262.569 568.724 262.451C569.457 262.067 569.742 261.151 569.364 260.407L569.295 260.275C568.91 259.534 568.005 259.235 567.272 259.625C566.543 260.013 566.254 260.918 566.639 261.659L566.652 261.686L566.712 261.804C566.977 262.323 567.498 262.623 568.038 262.623ZM564.427 255.924C564.679 255.924 564.938 255.86 565.173 255.722C565.886 255.305 566.132 254.378 565.72 253.651L565.641 253.513C565.233 252.786 564.325 252.53 563.605 252.944C562.889 253.358 562.637 254.284 563.045 255.012L563.131 255.167C563.406 255.651 563.91 255.924 564.424 255.924H564.427ZM560.588 249.357C560.86 249.357 561.132 249.283 561.377 249.125C562.077 248.68 562.289 247.748 561.851 247.037L561.765 246.896C561.331 246.185 560.409 245.966 559.709 246.407C559.01 246.848 558.794 247.785 559.229 248.495L559.318 248.643C559.6 249.101 560.087 249.354 560.585 249.354L560.588 249.357ZM556.53 242.928C556.815 242.928 557.103 242.844 557.359 242.673C558.045 242.208 558.227 241.265 557.77 240.571L557.677 240.426C557.219 239.733 556.291 239.547 555.608 240.012C554.925 240.48 554.743 241.42 555.2 242.113L555.293 242.252C555.582 242.689 556.052 242.925 556.533 242.925L556.53 242.928ZM552.256 236.648C552.558 236.648 552.863 236.553 553.128 236.361C553.798 235.873 553.947 234.924 553.466 234.247L553.373 234.115C552.893 233.435 551.961 233.277 551.291 233.762C550.621 234.247 550.466 235.193 550.943 235.877L551.046 236.021C551.338 236.432 551.795 236.651 552.256 236.651V236.648ZM547.77 230.519C548.088 230.519 548.407 230.418 548.679 230.205C549.332 229.694 549.454 228.744 548.95 228.08L548.848 227.942C548.344 227.279 547.405 227.158 546.755 227.67C546.102 228.181 545.983 229.131 546.487 229.795L546.586 229.926C546.881 230.313 547.322 230.519 547.77 230.519ZM543.078 224.554C543.413 224.554 543.748 224.44 544.027 224.211C544.663 223.679 544.756 222.726 544.232 222.079L544.12 221.945C543.592 221.301 542.654 221.21 542.018 221.746C541.384 222.281 541.295 223.234 541.822 223.881L541.925 224.006C542.22 224.369 542.647 224.558 543.078 224.558V224.554ZM538.185 218.759C538.54 218.759 538.894 218.631 539.179 218.371C539.793 217.812 539.846 216.856 539.295 216.233L539.189 216.112C538.642 215.485 537.701 215.428 537.084 215.984C536.467 216.539 536.411 217.496 536.958 218.122L537.074 218.254C537.369 218.587 537.777 218.759 538.188 218.759H538.185ZM533.092 213.141C533.46 213.141 533.831 213.003 534.12 212.724C534.717 212.148 534.74 211.188 534.173 210.582L534.057 210.457C533.487 209.851 532.545 209.831 531.948 210.41C531.351 210.99 531.331 211.949 531.902 212.552L532.015 212.673C532.306 212.987 532.701 213.145 533.095 213.145L533.092 213.141ZM527.807 207.709C528.195 207.709 528.58 207.558 528.871 207.255C529.448 206.659 529.438 205.699 528.848 205.113L528.726 204.992C528.135 204.409 527.19 204.419 526.617 205.019C526.04 205.618 526.053 206.578 526.643 207.161L526.759 207.278C527.051 207.568 527.426 207.713 527.804 207.713L527.807 207.709ZM522.336 202.473C522.744 202.473 523.149 202.304 523.44 201.974C523.994 201.355 523.948 200.395 523.338 199.832L523.215 199.721C522.605 199.159 521.663 199.203 521.106 199.822C520.553 200.442 520.596 201.402 521.206 201.964L521.332 202.079C521.617 202.341 521.975 202.473 522.333 202.473H522.336ZM516.687 197.438C517.111 197.438 517.535 197.253 517.831 196.899C518.361 196.259 518.278 195.303 517.648 194.764L517.526 194.66C516.899 194.118 515.957 194.198 515.423 194.835C514.89 195.475 514.969 196.431 515.596 196.97L515.728 197.084C516.007 197.324 516.348 197.441 516.687 197.441V197.438ZM510.861 192.616C511.306 192.616 511.743 192.417 512.038 192.033C512.546 191.373 512.433 190.42 511.783 189.905L511.654 189.8C511.004 189.285 510.069 189.399 509.558 190.056C509.048 190.716 509.164 191.666 509.81 192.185L509.943 192.289C510.215 192.504 510.54 192.612 510.861 192.612V192.616ZM504.87 188.009C505.331 188.009 505.785 187.793 506.077 187.382C506.561 186.705 506.415 185.759 505.745 185.264L505.609 185.163C504.943 184.671 504.008 184.823 503.524 185.5C503.04 186.177 503.186 187.123 503.855 187.618L503.991 187.719C504.257 187.914 504.562 188.009 504.867 188.009H504.87ZM498.72 183.624C499.197 183.624 499.668 183.392 499.956 182.96C500.421 182.267 500.241 181.327 499.562 180.856L499.416 180.755C498.733 180.287 497.805 180.472 497.347 181.169C496.889 181.863 497.068 182.806 497.755 183.27L497.887 183.361C498.143 183.54 498.435 183.624 498.726 183.624H498.72ZM492.417 179.465C492.914 179.465 493.401 179.212 493.683 178.751C494.118 178.04 493.905 177.107 493.206 176.663L493.063 176.572C492.364 176.131 491.445 176.346 491.008 177.057C490.573 177.768 490.786 178.7 491.485 179.145L491.628 179.236C491.873 179.391 492.145 179.465 492.417 179.465ZM485.971 175.538C486.489 175.538 486.993 175.265 487.268 174.777C487.679 174.05 487.43 173.124 486.717 172.709L486.571 172.625C485.855 172.208 484.944 172.46 484.536 173.184C484.128 173.908 484.373 174.838 485.086 175.252L485.232 175.336C485.467 175.474 485.723 175.538 485.975 175.538H485.971ZM479.393 171.847C479.93 171.847 480.448 171.554 480.716 171.036C481.101 170.295 480.819 169.379 480.089 168.988L479.947 168.911C479.218 168.517 478.316 168.799 477.931 169.54C477.546 170.281 477.822 171.197 478.551 171.588L478.704 171.669C478.926 171.787 479.165 171.844 479.397 171.844L479.393 171.847ZM472.712 168.405C473.249 168.405 473.767 168.112 474.035 167.594C474.42 166.853 474.138 165.937 473.409 165.546L473.266 165.469C472.537 165.075 471.635 165.358 471.25 166.099C470.866 166.839 471.141 167.755 471.87 168.146L472.023 168.227C472.245 168.345 472.484 168.402 472.716 168.402L472.712 168.405ZM472.033 168.247L473.336 165.523L473.183 165.449C472.441 165.085 471.549 165.405 471.194 166.159C470.836 166.914 471.151 167.819 471.893 168.18L472.036 168.251L472.033 168.247ZM465.862 165.203C466.436 165.203 466.983 164.866 467.229 164.297C467.56 163.532 467.219 162.637 466.463 162.3L466.31 162.233C465.557 161.896 464.675 162.243 464.344 163.01C464.012 163.778 464.354 164.671 465.11 165.007L465.262 165.075C465.458 165.162 465.66 165.203 465.862 165.203ZM458.93 162.256C459.523 162.256 460.083 161.892 460.316 161.3C460.621 160.522 460.243 159.639 459.477 159.333L459.324 159.272C458.558 158.963 457.69 159.343 457.388 160.121C457.083 160.899 457.457 161.781 458.223 162.088L458.379 162.152C458.558 162.226 458.744 162.259 458.93 162.259V162.256ZM451.897 159.565C452.511 159.565 453.084 159.178 453.303 158.562C453.582 157.774 453.177 156.905 452.401 156.625L452.239 156.568C451.463 156.289 450.611 156.699 450.332 157.491C450.057 158.279 450.462 159.148 451.241 159.427L451.393 159.481C451.559 159.542 451.728 159.569 451.897 159.569V159.565ZM444.775 157.131C445.409 157.131 445.999 156.716 446.198 156.07C446.447 155.272 446.009 154.42 445.223 154.17L445.067 154.12C444.281 153.867 443.443 154.308 443.194 155.107C442.945 155.905 443.38 156.757 444.165 157.009L444.328 157.063C444.477 157.11 444.626 157.134 444.775 157.134V157.131ZM437.571 154.955C438.224 154.955 438.827 154.514 439.006 153.844C439.225 153.035 438.758 152.204 437.965 151.981L437.806 151.938C437.014 151.715 436.192 152.187 435.969 152.992C435.751 153.8 436.215 154.632 437.007 154.857L437.17 154.904C437.302 154.942 437.435 154.958 437.567 154.958L437.571 154.955ZM430.296 153.042C430.973 153.042 431.583 152.574 431.745 151.877C431.938 151.062 431.44 150.247 430.638 150.052L430.479 150.011C429.68 149.816 428.874 150.318 428.682 151.133C428.49 151.948 428.983 152.766 429.786 152.958L429.952 152.998C430.068 153.025 430.184 153.039 430.3 153.039L430.296 153.042ZM422.959 151.389C423.652 151.389 424.275 150.894 424.418 150.176C424.584 149.358 424.063 148.556 423.258 148.388L423.088 148.354C422.283 148.189 421.494 148.718 421.331 149.54C421.169 150.362 421.689 151.16 422.498 151.325L422.657 151.358C422.76 151.379 422.86 151.389 422.959 151.389ZM415.569 149.994C416.285 149.994 416.918 149.469 417.038 148.725C417.173 147.9 416.623 147.118 415.811 146.984L415.648 146.957C414.836 146.819 414.067 147.374 413.931 148.199C413.795 149.025 414.342 149.806 415.154 149.944L415.323 149.971C415.406 149.984 415.489 149.991 415.569 149.991V149.994ZM408.135 148.863C408.871 148.863 409.515 148.307 409.614 147.546C409.72 146.718 409.146 145.957 408.328 145.845L408.162 145.822C407.343 145.711 406.597 146.297 406.487 147.125C406.378 147.954 406.955 148.718 407.771 148.826L407.936 148.849C408.003 148.86 408.069 148.863 408.132 148.863H408.135ZM400.669 147.991C401.428 147.991 402.074 147.408 402.151 146.623C402.234 145.792 401.633 145.047 400.814 144.967L400.645 144.95C399.826 144.872 399.097 145.478 399.017 146.314C398.938 147.145 399.538 147.886 400.36 147.967L400.523 147.984C400.572 147.991 400.622 147.991 400.672 147.991H400.669ZM362.961 147.57C363 147.57 363.04 147.57 363.08 147.566L363.243 147.553C364.065 147.489 364.681 146.761 364.618 145.926C364.555 145.091 363.839 144.465 363.017 144.529L362.845 144.542C362.022 144.61 361.409 145.337 361.475 146.172C361.538 146.967 362.191 147.57 362.961 147.57ZM393.175 147.378C393.958 147.378 394.614 146.758 394.664 145.957C394.714 145.121 394.091 144.401 393.265 144.35L393.099 144.34C392.27 144.286 391.571 144.926 391.518 145.761C391.468 146.596 392.095 147.314 392.917 147.368L393.083 147.378C393.112 147.378 393.146 147.378 393.175 147.378ZM370.464 147.115C370.484 147.115 370.504 147.115 370.527 147.115L370.699 147.108C371.521 147.071 372.161 146.364 372.125 145.529C372.088 144.694 371.409 144.047 370.57 144.081L370.408 144.088C369.585 144.121 368.942 144.828 368.978 145.664C369.012 146.479 369.671 147.118 370.467 147.118L370.464 147.115ZM385.662 147.024C386.468 147.024 387.131 146.371 387.154 145.549C387.178 144.714 386.524 144.017 385.702 143.993H385.54C384.714 143.963 384.028 144.623 384.005 145.458C383.981 146.293 384.628 146.994 385.453 147.017H385.626C385.626 147.017 385.652 147.024 385.666 147.024H385.662ZM377.977 146.933H378.153C378.978 146.927 379.641 146.246 379.635 145.408C379.631 144.573 378.962 143.902 378.143 143.902H377.967C377.141 143.909 376.478 144.589 376.485 145.428C376.488 146.263 377.158 146.933 377.977 146.933Z",
    fill: "#5B8AEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M574.802 279.331L575.959 275.104C576.175 274.296 575.707 273.464 574.912 273.245C574.733 273.198 574.554 273.181 574.381 273.198C574.212 273.208 574.043 273.248 573.877 273.319C573.121 273.649 572.77 274.538 573.095 275.309L574.802 279.331Z",
    fill: "#5B8AEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M574.136 281.703C573.69 281.258 573.566 280.552 573.875 279.952L573.95 279.807C574.331 279.065 575.238 278.763 575.977 279.135C576.714 279.505 577.002 280.407 576.619 281.152L576.537 281.309C576.151 282.051 575.241 282.347 574.507 281.974C574.363 281.902 574.241 281.809 574.136 281.703ZM577.478 274.891C577.051 274.465 576.912 273.797 577.186 273.209L577.256 273.055C577.607 272.296 578.501 271.956 579.254 272.295C580.007 272.634 580.334 273.522 579.983 274.281L579.911 274.433C579.56 275.192 578.666 275.532 577.915 275.195C577.746 275.121 577.6 275.018 577.476 274.894L577.478 274.891ZM580.526 267.947C580.114 267.535 579.97 266.896 580.211 266.317L580.271 266.168C580.589 265.395 581.468 265.017 582.236 265.323C583.004 265.629 583.368 266.503 583.05 267.276L582.983 267.437C582.663 268.207 581.781 268.583 581.015 268.274C580.824 268.198 580.66 268.086 580.524 267.95L580.526 267.947ZM583.28 260.885C582.884 260.489 582.732 259.885 582.94 259.317L582.998 259.156C583.285 258.371 584.151 257.961 584.929 258.233C585.709 258.508 586.108 259.365 585.821 260.149L585.763 260.306C585.476 261.09 584.612 261.503 583.832 261.228C583.618 261.152 583.43 261.031 583.28 260.881L583.28 260.885ZM585.739 253.719C585.359 253.339 585.201 252.762 585.38 252.207L585.428 252.056C585.68 251.26 586.525 250.809 587.317 251.049C588.109 251.288 588.547 252.126 588.295 252.922L588.242 253.087C587.987 253.881 587.138 254.327 586.348 254.085C586.108 254.011 585.903 253.883 585.739 253.719ZM587.899 246.463C587.536 246.1 587.372 245.555 587.52 245.018L587.567 244.845C587.793 244.042 588.621 243.561 589.42 243.774C590.22 243.988 590.688 244.809 590.462 245.611L590.421 245.765C590.202 246.57 589.376 247.054 588.574 246.848C588.31 246.779 588.079 246.643 587.899 246.463ZM589.755 239.127C589.405 238.777 589.242 238.261 589.359 237.741L589.398 237.57C589.586 236.758 590.396 236.244 591.205 236.42C592.014 236.595 592.516 237.397 592.328 238.209L592.291 238.367C592.103 239.179 591.298 239.698 590.489 239.523C590.198 239.461 589.949 239.316 589.757 239.124L589.755 239.127ZM591.301 231.724C590.968 231.391 590.8 230.904 590.896 230.4L590.925 230.229C591.081 229.413 591.867 228.861 592.683 229.006C593.5 229.146 594.037 229.926 593.88 230.745L593.85 230.906C593.697 231.724 592.913 232.274 592.094 232.136C591.78 232.084 591.507 231.935 591.299 231.727L591.301 231.724ZM592.532 224.268C592.215 223.951 592.046 223.492 592.114 223.007L592.139 222.832C592.259 222.009 593.026 221.429 593.845 221.538C594.669 221.647 595.235 222.404 595.113 223.224L595.09 223.383C594.975 224.206 594.212 224.791 593.391 224.688C593.051 224.644 592.752 224.493 592.529 224.27L592.532 224.268ZM593.441 216.771C593.139 216.469 592.967 216.035 593.016 215.569L593.033 215.401C593.116 214.574 593.855 213.961 594.682 214.03C595.508 214.099 596.11 214.829 596.028 215.657L596.01 215.825C595.928 216.652 595.188 217.265 594.361 217.196C593.998 217.166 593.678 217.008 593.441 216.771ZM594.027 209.246C593.741 208.96 593.574 208.555 593.596 208.115L593.607 207.945C593.654 207.116 594.365 206.47 595.197 206.506C596.026 206.539 596.661 207.241 596.614 208.07L596.606 208.234C596.559 209.063 595.852 209.709 595.021 209.678C594.633 209.662 594.285 209.499 594.032 209.246L594.027 209.246ZM594.284 201.707C594.012 201.435 593.848 201.056 593.853 200.638L593.855 200.477C593.863 199.648 594.542 198.969 595.372 198.965C596.201 198.961 596.869 199.629 596.86 200.459L596.859 200.633C596.848 201.465 596.164 202.139 595.335 202.138C594.921 202.139 594.552 201.974 594.284 201.707ZM594.216 194.171C593.96 193.915 593.798 193.567 593.784 193.173L593.779 192.995C593.754 192.166 594.41 191.464 595.242 191.429C596.071 191.392 596.763 192.036 596.785 192.868L596.791 193.026C596.82 193.855 596.169 194.562 595.337 194.602C594.9 194.622 594.5 194.455 594.216 194.171ZM593.819 186.649C593.577 186.408 593.417 186.081 593.391 185.712L593.379 185.542C593.319 184.716 593.944 183.988 594.771 183.915C595.599 183.843 596.317 184.456 596.377 185.282L596.387 185.445C596.447 186.272 595.825 187.002 594.997 187.075C594.538 187.116 594.112 186.947 593.814 186.649L593.819 186.649ZM593.095 179.158C592.868 178.931 592.714 178.63 592.675 178.285L592.655 178.127C592.552 177.305 593.14 176.545 593.963 176.43C594.788 176.317 595.538 176.89 595.64 177.711L595.662 177.886C595.757 178.71 595.17 179.466 594.345 179.574C593.864 179.636 593.412 179.47 593.098 179.156L593.095 179.158ZM592.05 171.712C591.839 171.501 591.693 171.226 591.641 170.907L591.614 170.742C591.481 169.923 592.037 169.142 592.856 168.998C593.677 168.853 594.45 169.397 594.581 170.213L594.608 170.379C594.741 171.197 594.187 171.977 593.368 172.125C592.866 172.214 592.383 172.045 592.053 171.715L592.05 171.712ZM590.684 164.321C590.487 164.124 590.344 163.872 590.283 163.577L590.251 163.417C590.08 162.608 590.604 161.803 591.416 161.619C592.228 161.436 593.025 161.947 593.196 162.756L593.23 162.923C593.398 163.735 592.877 164.538 592.063 164.719C591.544 164.834 591.031 164.668 590.686 164.323L590.684 164.321ZM588.995 157.003C588.814 156.822 588.679 156.592 588.61 156.323L588.569 156.163C588.365 155.359 588.851 154.535 589.659 154.318C590.464 154.099 591.282 154.575 591.486 155.379L591.527 155.539C591.734 156.341 591.245 157.167 590.438 157.384C589.9 157.527 589.358 157.366 588.995 157.003ZM586.989 149.768C586.822 149.601 586.694 149.392 586.62 149.152L586.574 149.001C586.332 148.211 586.781 147.364 587.574 147.11C588.368 146.856 589.208 147.291 589.45 148.08L589.501 148.245C589.74 149.037 589.285 149.882 588.491 150.132C587.939 150.304 587.366 150.145 586.989 149.768ZM584.672 142.632C584.52 142.479 584.401 142.294 584.327 142.077L584.272 141.921C583.997 141.142 584.414 140.278 585.196 139.993C585.981 139.706 586.838 140.11 587.11 140.888L587.163 141.046C587.439 141.826 587.021 142.689 586.239 142.974C585.672 143.179 585.066 143.026 584.672 142.632ZM582.048 135.607C581.91 135.469 581.798 135.304 581.724 135.111L581.661 134.958C581.355 134.19 581.733 133.311 582.506 132.993C583.278 132.675 584.152 133.039 584.458 133.807L584.518 133.962C584.824 134.73 584.446 135.609 583.674 135.927C583.095 136.163 582.461 136.02 582.05 135.609L582.048 135.607ZM579.123 128.705C579.001 128.583 578.896 128.435 578.821 128.266L578.756 128.12C578.415 127.369 578.753 126.473 579.509 126.12C580.266 125.766 581.156 126.09 581.498 126.841L581.57 126.999C581.909 127.752 581.566 128.648 580.807 128.994C580.217 129.266 579.552 129.129 579.125 128.703L579.123 128.705ZM575.908 121.938C575.8 121.83 575.707 121.703 575.634 121.559L575.56 121.409C575.19 120.672 575.493 119.765 576.237 119.381C576.98 119 577.883 119.288 578.255 120.027L578.329 120.173C578.699 120.909 578.399 121.819 577.657 122.2C577.059 122.507 576.358 122.383 575.913 121.938L575.908 121.938ZM572.408 115.314C572.315 115.221 572.23 115.112 572.163 114.988L572.084 114.847C571.683 114.127 571.945 113.208 572.669 112.794C573.395 112.382 574.31 112.63 574.713 113.347L574.797 113.498C575.198 114.217 574.933 115.139 574.205 115.548C573.602 115.889 572.87 115.776 572.408 115.314ZM568.634 108.849C568.554 108.769 568.481 108.678 568.418 108.577L568.334 108.44C567.9 107.74 568.123 106.809 568.83 106.364C569.538 105.919 570.463 106.129 570.899 106.828L570.99 106.976C571.422 107.679 571.195 108.609 570.482 109.049C569.874 109.428 569.107 109.327 568.629 108.849L568.634 108.849ZM564.586 102.549C564.52 102.483 564.459 102.408 564.403 102.328L564.315 102.197C563.852 101.515 564.034 100.578 564.723 100.105C565.412 99.6316 566.347 99.7991 566.809 100.481L566.907 100.626C567.367 101.31 567.18 102.247 566.487 102.716C565.876 103.129 565.078 103.046 564.584 102.551L564.586 102.549ZM560.275 96.428C560.223 96.3764 560.176 96.3201 560.132 96.2614L560.031 96.1275C559.54 95.4651 559.687 94.5213 560.36 94.0222C561.03 93.5208 561.971 93.6575 562.46 94.3176L562.558 94.4491C563.049 95.1116 562.903 96.0554 562.232 96.5568C561.621 97.0128 560.788 96.9461 560.272 96.4304L560.275 96.428ZM555.702 90.5029C555.664 90.4654 555.627 90.4279 555.596 90.3833L555.493 90.2565C554.974 89.6179 555.08 88.6673 555.727 88.1377C556.374 87.6082 557.321 87.6976 557.843 88.3385L557.95 88.47C558.468 89.1109 558.361 90.0568 557.709 90.5864C557.103 91.0802 556.234 91.0304 555.702 90.4982L555.702 90.5029Z",
    fill: "#5B8AEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M570.885 143.289C544.605 143.289 523.265 122.022 523.221 95.7879C523.177 69.554 544.446 48.2871 570.726 48.2871C597.006 48.2871 618.346 69.554 618.39 95.7879C618.434 122.022 597.165 143.289 570.885 143.289Z",
    fill: "#795ECF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_236_26657",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 523,
    y: 48,
    width: 96,
    height: 96
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M570.885 143.289C544.605 143.289 523.265 122.022 523.221 95.7879C523.177 69.554 544.446 48.2871 570.726 48.2871C597.006 48.2871 618.346 69.554 618.39 95.7879C618.434 122.022 597.165 143.289 570.885 143.289Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_236_26657)"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M575.963 58.2033C582.885 59.8301 587.013 63.9813 588.309 65.3212C589.288 66.3304 590.564 67.6736 591.651 69.7999C592.151 70.7787 592.859 72.4223 593.551 77.2216C594.402 83.111 593.717 83.3068 594.55 86.7831C595.533 90.8803 596.461 90.5192 596.964 93.9651C597.463 97.3942 596.68 98.6902 597.44 101.836C597.997 104.137 599.006 105.886 599.775 107.01C594.263 109.463 584.35 113.027 571.514 113.118C558.495 113.21 548.417 109.686 542.857 107.276C543.526 106.173 544.403 104.441 544.845 102.193C545.537 98.68 544.478 97.3705 544.845 93.4892C545.213 89.581 546.337 90.364 546.84 86.0676C547.249 82.5676 546.668 80.627 547.995 77.4173C548.464 76.28 548.572 76.4386 549.162 75.0042C550.313 72.2198 550.199 70.9103 551.066 68.5478C551.066 68.5478 551.822 66.489 553.115 64.6125C556.676 59.4386 563.619 58.3113 566.134 57.9029C570.94 57.1233 574.737 57.9164 575.959 58.2033H575.963Z",
    fill: "#EDB98E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M576.668 95.2908C576.456 97.1572 576.243 99.8539 576.324 103.097C576.398 106.03 576.537 107.404 576.732 108.433C576.763 108.595 577.239 111.062 577.995 112.787C579.959 117.259 585.015 119.432 586.774 120.107C585.805 121.427 584.084 123.418 581.384 125.055C576.982 127.725 572.739 127.772 571.031 127.769C565.837 127.762 562.151 125.828 561.351 125.393C557.895 123.513 555.819 121.025 554.786 119.588C556.521 118.963 561.695 116.871 563.555 112.483C564.004 111.423 564.443 109.797 564.709 108.362C564.99 106.857 565.037 105.5 565.108 103.037C565.206 99.6446 565.013 96.84 564.824 94.9297C568.77 95.0512 572.719 95.1693 576.665 95.2908H576.668Z",
    fill: "url(#paint0_linear_236_26657)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M539.114 131.84C539.732 129.869 540.438 127.618 542.189 125.694C544.238 123.443 546.574 122.889 549.196 121.971C552.201 120.918 556.325 119.123 561.074 115.873C562.198 116.703 565.746 119.102 570.869 119.069C575.726 119.038 579.112 116.834 580.27 116.004C585.046 119.261 589.147 121.188 592.134 122.373C595.118 123.554 597.966 124.381 600.015 127.209C601.028 128.603 601.554 130.085 602.216 131.948C603.215 134.756 603.674 137.189 603.91 138.887C599.502 141.857 588.094 148.688 571.99 148.995C554.661 149.326 542.324 141.908 537.977 139.002C537.997 137.318 538.196 134.776 539.114 131.84Z",
    fill: "#F58199"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M585.751 78.4101C587.051 84.3164 585.296 89.3283 583.73 93.7799C582.845 96.2943 582.285 97.8806 580.938 99.8213C580.938 99.8213 578.883 102.778 572.334 106.608C572.004 106.801 571.386 107.148 570.576 107.138C569.695 107.128 569.037 106.7 568.716 106.487C564.477 103.662 562.357 102.251 560.366 99.3285C559.144 97.5397 558.519 96.0581 557.854 94.4583C556.342 90.8302 553.952 85.0521 555.282 78.2211C555.667 76.2399 556.106 73.9955 557.851 71.7747C561.294 67.3906 566.954 66.7595 568.011 66.6413C568.308 66.6076 569.455 66.4894 571.015 66.5873C572.527 66.6818 578.889 67.0835 582.811 71.7207C584.803 74.0731 585.346 76.5437 585.758 78.4101H585.751Z",
    fill: "url(#paint1_linear_236_26657)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M563.059 64.4807C561.571 63.0902 558.536 63.4581 556.818 64.5381C550.712 68.3789 554.513 85.4734 554.638 85.4667C554.665 85.4667 554.573 84.6701 554.749 83.1818C554.874 82.0984 555.07 80.8429 555.6 79.6515C556.153 78.4027 557.051 77.7581 557.807 77.1371C559.208 75.9929 563.91 72.1488 564.085 67.8085C564.109 67.2482 564.176 65.5236 563.062 64.4807H563.059Z",
    fill: "#EDB98E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M573.719 73.6572C575.896 74.6933 578.643 75.6282 581.877 75.9117C582.42 75.959 582.947 75.986 583.46 75.9961C583.814 77.0322 584.331 78.713 584.722 80.8494C585.245 83.7013 585.252 85.7601 585.849 85.8478C585.961 85.8647 586.187 85.8242 587.031 84.3358C588.128 82.3918 589.049 80.8325 589.171 78.5409C589.218 77.6296 589.252 76.9884 589.042 76.1244C588.958 75.7767 588.317 73.2995 586.011 71.9832C585.38 71.6221 584.388 71.2137 582.424 71.1968C578.825 71.1664 575.767 72.4793 573.719 73.6606V73.6572Z",
    fill: "#EDB98E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M561.573 58.9223C560.584 60.4883 561.307 62.7799 561.675 63.9544C562.748 67.3666 565.35 69.1925 568.037 71.0184C575.162 75.8615 581.616 75.8345 585.555 75.8244C586.834 75.8244 588.009 75.7367 588.795 74.9132C590.709 72.905 588.9 67.8863 587.168 65.1728C581.322 56.013 564.419 54.4132 561.573 58.9223Z",
    fill: "#EDB98E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M588.451 87.6673C588.931 90.6477 585.771 95.3056 584.303 94.4753C583.49 94.0162 583.263 91.9033 583.29 90.6477C583.334 88.6765 584.073 85.9762 585.559 85.3619C586.838 84.832 588.188 86.0437 588.448 87.6673H588.451Z",
    fill: "url(#paint2_linear_236_26657)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M587.496 88.4516C587.716 90.0616 586.598 92.2859 585.663 92.0362C585.063 91.8775 584.519 90.6928 584.664 89.2752C584.796 88.0027 585.431 87.0474 586.092 86.9124C586.754 86.7808 587.365 87.4795 587.496 88.4482V88.4516Z",
    fill: "url(#paint3_radial_236_26657)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M585.694 89.3448C585.906 90.1245 585.552 91.4747 585.106 91.5253C584.819 91.559 584.485 91.0595 584.452 90.3068C584.421 89.6317 584.644 89.0208 584.941 88.8284C585.235 88.636 585.565 88.8757 585.694 89.3448Z",
    fill: "url(#paint4_linear_236_26657)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M552.64 87.8532C552.37 90.8606 555.85 95.2823 557.257 94.3541C558.037 93.8376 558.115 91.7146 557.996 90.4657C557.814 88.5046 556.886 85.8618 555.36 85.3521C554.047 84.9133 552.785 86.2162 552.64 87.8532Z",
    fill: "url(#paint5_linear_236_26657)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M553.649 88.5689C553.545 90.1891 554.814 92.329 555.729 92.0151C556.316 91.8126 556.775 90.5941 556.532 89.19C556.313 87.931 555.61 87.0197 554.939 86.9353C554.27 86.8509 553.71 87.5901 553.646 88.5689H553.649Z",
    fill: "url(#paint6_radial_236_26657)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M555.509 89.3363C555.351 90.1295 555.799 91.4526 556.248 91.4728C556.535 91.4863 556.832 90.9632 556.815 90.2105C556.799 89.5354 556.532 88.9414 556.225 88.7692C555.918 88.5971 555.607 88.8603 555.509 89.3363Z",
    fill: "url(#paint7_linear_236_26657)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M574.623 79.9662C574.775 80.054 574.94 80.027 575.092 79.9865C575.251 79.9426 575.399 79.865 575.49 79.8211C575.646 79.7502 575.852 79.6624 576.101 79.5781C576.307 79.5105 576.712 79.3789 577.215 79.335C577.954 79.2709 578.528 79.4262 578.852 79.5173C578.994 79.5578 579.544 79.7164 580.189 80.1012C580.776 80.4523 581.195 80.8404 581.289 80.9282C581.92 81.5222 582.184 82.0184 582.521 81.9475C582.535 81.9475 582.673 81.9104 582.734 81.8058C582.977 81.4041 581.438 79.3519 579.176 78.6296C579.058 78.5925 577.617 78.1503 575.987 78.5756C575.592 78.6802 574.471 78.9705 574.41 79.5308C574.4 79.6354 574.427 79.7266 574.454 79.7907C574.485 79.8413 574.535 79.9156 574.623 79.9696V79.9662Z",
    fill: "#EDB98E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M566.306 79.9662C566.154 80.054 565.989 80.027 565.837 79.9865C565.678 79.9426 565.53 79.865 565.438 79.8211C565.283 79.7502 565.077 79.6624 564.824 79.5781C564.618 79.5105 564.213 79.3789 563.71 79.335C562.971 79.2709 562.397 79.4262 562.073 79.5173C561.931 79.5578 561.381 79.7164 560.737 80.1012C560.149 80.4523 559.731 80.8404 559.636 80.9282C559.005 81.5222 558.742 82.0184 558.404 81.9475C558.391 81.9475 558.252 81.9104 558.192 81.8058C557.949 81.4041 559.488 79.3519 561.749 78.6296C561.867 78.5925 563.309 78.1503 564.939 78.5756C565.334 78.6802 566.458 78.9705 566.515 79.5308C566.525 79.6354 566.498 79.7266 566.471 79.7907C566.444 79.8413 566.39 79.9156 566.303 79.9696L566.306 79.9662Z",
    fill: "#EDB98E"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.1,
    d: "M565.287 91.6764C565.287 94.596 562.921 96.9621 560.001 96.9621C557.081 96.9621 554.715 94.596 554.715 91.6764C554.715 88.7567 557.081 86.3906 560.001 86.3906C562.921 86.3906 565.287 88.7567 565.287 91.6764Z",
    fill: "url(#paint8_radial_236_26657)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "color-burn"
    },
    opacity: 0.1,
    d: "M586.238 91.6764C586.238 94.596 583.871 96.9621 580.952 96.9621C578.032 96.9621 575.666 94.596 575.666 91.6764C575.666 88.7567 578.032 86.3906 580.952 86.3906C583.871 86.3906 586.238 88.7567 586.238 91.6764Z",
    fill: "url(#paint9_radial_236_26657)"
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M566.522 80.9717C567.349 81.7277 568.615 83.1317 569.158 85.2073C569.458 86.3616 569.425 87.6441 569.421 87.9884C569.415 88.6026 569.408 89.1055 569.263 89.7771C569.134 90.3711 568.929 91.3161 568.253 92.224C568.061 92.4839 567.886 92.5784 567.835 92.8383C567.717 93.4357 568.311 94.0128 568.591 94.2862C568.915 94.6034 569.35 95.0287 570.032 95.1063C570.798 95.1941 571.386 94.7891 571.811 94.4921C572.51 94.0094 572.895 93.3952 573.097 92.9935C572.83 92.7607 572.466 92.3928 572.142 91.8764C571.366 90.6344 571.355 89.362 571.359 88.1335C571.359 87.4416 571.366 86.4325 571.737 85.2006C572.368 83.1081 573.651 81.7378 574.42 81.0426C571.787 81.0189 569.158 80.9953 566.525 80.9751L566.522 80.9717Z",
    fill: "url(#paint10_linear_236_26657)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M573.904 97.9878C573.735 98.1937 572.472 99.6822 570.255 99.77C567.815 99.8645 566.356 98.1734 566.221 98.0114C566.286 98.3287 566.4 98.7742 566.613 99.2839C566.869 99.8982 567.109 100.472 567.666 100.992C567.889 101.198 568.628 101.869 569.816 101.977C571.183 102.099 572.159 101.383 572.391 101.198C573.154 100.597 573.428 99.8408 573.623 99.2974C573.812 98.7742 573.88 98.3152 573.907 97.9878H573.904Z",
    fill: "#EA756C"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M566.147 97.6453C566.35 97.669 566.515 97.6622 566.667 97.6386C567.048 97.5845 567.882 97.3244 567.882 97.3244C568.372 97.1724 568.615 97.0981 568.797 97.0947C569.087 97.0913 569.512 97.1724 570.032 97.598C570.481 97.1994 570.869 97.1082 571.133 97.0947C571.389 97.0812 571.656 97.1623 572.186 97.3244C572.186 97.3244 573.033 97.5845 573.401 97.6386C573.553 97.6588 573.718 97.669 573.921 97.6453C574.181 97.6115 574.386 97.5338 574.518 97.4697C574.39 97.6183 574.187 97.8277 573.89 98.0237C573.357 98.3716 572.837 98.4493 571.818 98.5945C571.298 98.6688 570.798 98.7398 570.1 98.7398C569.404 98.7398 568.922 98.6722 568.253 98.581C566.758 98.3716 566.357 98.1385 566.178 98.0237C565.877 97.8277 565.671 97.6149 565.55 97.4697C565.681 97.5338 565.887 97.6115 566.147 97.6453Z",
    fill: "#EC7F76"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M575.23 81.6938H581.478V87.7357H575.23V81.6938Z",
    fill: "url(#paint11_radial_236_26657)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    d: "M559.495 81.6938H565.739V87.7357H559.495V81.6938Z",
    fill: "url(#paint12_radial_236_26657)"
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M564.324 86.0241C564.324 87.0198 563.788 87.8265 563.123 87.8265C562.458 87.8265 561.921 87.0198 561.921 86.0241C561.921 85.0284 562.458 84.2217 563.123 84.2217C563.784 84.2217 564.324 85.0284 564.324 86.0241Z",
    fill: "url(#paint13_linear_236_26657)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M579.028 86.0241C579.028 87.0198 578.491 87.8265 577.826 87.8265C577.162 87.8265 576.625 87.0198 576.625 86.0241C576.625 85.0284 577.162 84.2217 577.826 84.2217C578.488 84.2217 579.028 85.0284 579.028 86.0241Z",
    fill: "url(#paint14_linear_236_26657)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M568.007 70.2153C568.638 70.887 569.546 71.7882 570.721 72.7535C572.219 73.9855 574.292 75.6833 577.384 76.8039C579.503 77.5735 582.028 78.4916 584.917 77.6039C586.612 77.0841 587.807 76.1322 588.512 75.4639C587.405 75.9905 585.586 76.6858 583.277 76.7735C582.203 76.814 580.482 76.7465 577.552 75.7103C575.338 74.9272 571.828 73.378 568.007 70.2119V70.2153Z",
    fill: "#EDB98E"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "hard-light"
    },
    opacity: 0.3,
    d: "M568.952 92.521C568.973 92.8991 569.277 93.1691 569.374 93.2535C569.489 93.3547 569.712 93.5505 570.033 93.5471C570.333 93.5471 570.539 93.3716 570.664 93.267C570.775 93.1725 571.096 92.9058 571.116 92.5244C571.146 92.0248 570.66 91.4409 570.033 91.4409C569.405 91.4409 568.925 92.0215 568.949 92.5244L568.952 92.521Z",
    fill: "url(#paint15_linear_236_26657)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M570.805 143.705C583.605 143.705 595.641 138.72 604.69 129.672C613.74 120.623 618.725 108.588 618.725 95.7898C618.725 82.9917 613.74 70.9597 604.69 61.9079C595.641 52.8594 583.605 47.8745 570.805 47.8745C558.006 47.8745 545.973 52.8594 536.921 61.9079C527.868 70.9597 522.886 82.9917 522.886 95.7898C522.886 108.588 527.871 120.62 536.921 129.672C545.973 138.72 558.006 143.705 570.805 143.705ZM570.805 48.6271C583.406 48.6271 595.249 53.5344 604.157 62.4411C613.064 71.3479 617.972 83.1908 617.972 95.7898C617.972 108.389 613.064 120.232 604.157 129.139C595.249 138.045 583.406 142.953 570.805 142.953C558.205 142.953 546.361 138.045 537.454 129.139C528.546 120.232 523.639 108.389 523.639 95.7898C523.639 83.1908 528.546 71.3479 537.454 62.4411C546.361 53.5344 558.205 48.6271 570.805 48.6271Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M573.529 98.2119C573.469 98.2355 573.377 98.2693 573.263 98.3064C573.003 98.3874 572.787 98.4313 572.388 98.4954C572.041 98.5494 571.869 98.5764 571.585 98.6102C571.048 98.6743 570.589 98.725 569.982 98.7216C569.53 98.7182 569.158 98.6811 568.983 98.6642C568.76 98.6406 568.591 98.6203 568.325 98.5832C567.909 98.5258 567.673 98.4954 567.369 98.4313C567.163 98.3908 566.877 98.3267 566.539 98.2254C566.725 98.5562 567.329 99.5384 568.598 100.058C568.898 100.183 570.346 100.774 571.818 100.055C572.956 99.5013 573.408 98.5056 573.526 98.2153L573.529 98.2119Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M356.568 182.717C330.266 182.717 308.936 161.467 308.925 135.255C308.914 109.042 330.227 87.7925 356.529 87.7925C382.831 87.7925 404.161 109.042 404.172 135.255C404.182 161.467 382.869 182.717 356.568 182.717Z",
    fill: "#3EA4A8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_236_26657",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 308,
    y: 87,
    width: 97,
    height: 96
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M356.568 182.717C330.266 182.717 308.936 161.467 308.925 135.255C308.914 109.042 330.227 87.7925 356.529 87.7925C382.831 87.7925 404.161 109.042 404.172 135.255C404.182 161.467 382.869 182.717 356.568 182.717Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_236_26657)"
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M367.412 137.242C367.024 139.25 366.636 142.153 366.794 145.646C366.848 146.817 366.966 149.423 367.554 151.387C369.424 157.624 376.984 160.594 379.317 161.418C371.675 166.159 364.033 170.901 356.391 175.643C348.787 170.841 341.182 166.038 333.581 161.239C336.19 160.331 343.582 157.401 345.395 151.316C345.935 149.497 346.046 147.178 346.12 145.585C346.292 141.933 345.938 138.913 345.584 136.857C352.861 136.986 360.138 137.114 367.415 137.246L367.412 137.242Z",
    fill: "url(#paint16_linear_236_26657)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M316.786 171.62C317.11 170.955 317.65 169.828 318.71 168.606C319.797 167.351 321.025 166.406 322.504 165.542C325.281 163.918 331.857 160.85 340.805 157.34C342.904 159.72 345.419 162.298 348.389 164.911C351.437 167.587 354.39 169.794 357.08 171.6C359.754 169.825 362.71 167.624 365.755 164.911C368.502 162.464 370.825 160.044 372.762 157.809C375.665 159.271 378.051 160.324 379.628 160.995C384.68 163.156 388.629 164.438 392.201 167.584C392.491 167.84 392.798 168.113 393.193 168.518C396.285 171.681 397.345 175.194 398.185 178.11C398.61 179.578 399.106 181.671 399.36 184.26C392.616 188.077 377.349 195.522 356.581 195.515C335.806 195.509 320.539 188.043 313.799 184.219C313.839 183.807 313.907 183.169 314.008 182.39C314.491 178.667 315.021 175.262 316.786 171.623V171.62Z",
    fill: "#ED575A"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M351.029 104.089C356.801 101.872 361.901 103.661 362.984 104.069C364.169 104.515 367.456 105.797 369.91 108.936C374.308 114.565 372.843 122.102 371.166 130.718C369.964 136.891 368.294 140.077 367.227 141.846C364.196 146.868 360.662 149.079 358.738 149.389C357.432 149.598 356.021 149.551 356.021 149.551C356.021 149.551 354.701 149.507 353.493 149.244C352.227 148.967 349.263 147.664 346.29 143.034C344.886 140.847 343.134 137.377 342.064 130.715C341.743 128.727 339.759 114.555 344.153 109.02C346.715 105.794 350.02 104.477 351.029 104.093V104.089Z",
    fill: "url(#paint17_linear_236_26657)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M374.845 128.256C375.429 131.462 372.121 136.559 370.518 135.698C369.63 135.219 369.336 132.947 369.34 131.59C369.347 129.464 370.082 126.531 371.672 125.835C373.039 125.235 374.524 126.514 374.845 128.259V128.256Z",
    fill: "url(#paint18_linear_236_26657)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M373.829 129.122C374.102 130.853 372.944 133.28 371.932 133.034C371.28 132.875 370.666 131.609 370.791 130.077C370.902 128.7 371.567 127.653 372.279 127.495C372.988 127.339 373.667 128.079 373.829 129.122Z",
    fill: "url(#paint19_radial_236_26657)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M371.905 130.127C372.155 130.964 371.8 132.429 371.321 132.496C371.014 132.54 370.643 132.007 370.589 131.197C370.541 130.468 370.768 129.806 371.085 129.59C371.395 129.374 371.76 129.627 371.908 130.13L371.905 130.127Z",
    fill: "url(#paint20_linear_236_26657)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M338.49 128.082C337.875 131.285 341.136 136.412 342.746 135.565C343.64 135.096 343.951 132.824 343.961 131.468C343.978 129.341 343.269 126.401 341.683 125.689C340.319 125.075 338.824 126.34 338.49 128.082Z",
    fill: "url(#paint21_linear_236_26657)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M339.496 128.957C339.209 130.685 340.339 133.122 341.355 132.886C342.01 132.734 342.635 131.472 342.527 129.939C342.429 128.562 341.774 127.509 341.062 127.344C340.353 127.178 339.671 127.914 339.496 128.957Z",
    fill: "url(#paint22_radial_236_26657)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M341.409 129.982C341.152 130.816 341.493 132.284 341.972 132.355C342.279 132.399 342.657 131.873 342.718 131.063C342.772 130.333 342.553 129.668 342.239 129.449C341.928 129.23 341.564 129.479 341.409 129.982Z",
    fill: "url(#paint23_linear_236_26657)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M359.753 122.879L366.592 122.912L366.561 129.345L359.723 129.313L359.753 122.879Z",
    fill: "url(#paint24_radial_236_26657)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M346.01 122.821L352.848 122.853L352.818 129.286L345.979 129.254L346.01 122.821Z",
    fill: "url(#paint25_radial_236_26657)"
  }), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M362.296 126.902C362.292 127.898 362.788 128.708 363.41 128.711C364.031 128.711 364.537 127.908 364.54 126.912C364.544 125.916 364.047 125.106 363.426 125.103C362.805 125.103 362.299 125.906 362.296 126.902Z",
    fill: "url(#paint26_linear_236_26657)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M347.893 126.83C347.89 127.826 348.386 128.636 349.007 128.639C349.628 128.639 350.134 127.836 350.138 126.84C350.141 125.845 349.645 125.035 349.024 125.031C348.403 125.031 347.896 125.835 347.893 126.83Z",
    fill: "url(#paint27_linear_236_26657)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M368.205 123.131C368.448 122.405 366.582 120.684 364.573 120.343C362.241 119.945 359.787 121.244 359.612 122.085C359.568 122.486 359.851 122.594 359.949 122.632C360.111 122.692 360.27 122.645 360.408 122.588C360.557 122.524 360.688 122.436 360.773 122.382C360.911 122.294 361.1 122.186 361.336 122.075C361.525 121.983 361.903 121.808 362.39 121.7C363.102 121.541 363.686 121.609 364.016 121.649C364.158 121.666 364.722 121.74 365.407 122.014C365.734 122.142 366.143 122.304 366.602 122.635C366.933 122.871 367.557 123.391 367.837 123.377C367.837 123.377 368.124 123.374 368.212 123.131H368.205Z",
    fill: "url(#paint28_linear_236_26657)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M344.508 123.016C344.271 122.287 346.151 120.586 348.163 120.262C350.499 119.888 352.939 121.207 353.108 122.054C353.148 122.456 352.862 122.561 352.767 122.598C352.605 122.659 352.446 122.608 352.308 122.551C352.16 122.487 352.028 122.395 351.947 122.341C351.808 122.254 351.619 122.142 351.387 122.031C351.198 121.94 350.823 121.761 350.34 121.649C349.631 121.484 349.047 121.545 348.717 121.585C348.571 121.602 348.011 121.67 347.323 121.936C346.995 122.061 346.583 122.22 346.121 122.544C345.79 122.777 345.159 123.29 344.879 123.273C344.879 123.273 344.592 123.266 344.508 123.023V123.016Z",
    fill: "url(#paint29_linear_236_26657)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M354.357 123.11C354.502 123.407 354.694 123.87 354.789 124.454C354.863 124.913 354.86 125.311 354.816 125.821C354.728 126.813 354.583 127.106 354.411 128.099C354.249 129.034 354.04 130.721 353.857 131.75C353.817 131.977 353.776 132.189 353.631 132.422C353.486 132.655 353.354 132.719 353.179 133.006C353.162 133.033 352.993 133.31 352.953 133.505C352.781 134.299 354.262 135.466 355.565 135.777C355.758 135.824 355.876 135.834 355.937 135.838C356.743 135.888 357.361 135.416 357.763 135.105C358.37 134.639 358.745 134.099 358.971 133.691C358.802 133.306 358.556 132.695 358.343 131.923C357.962 130.529 358.168 130.36 357.783 128.149C357.671 127.515 357.516 126.742 357.506 125.706C357.503 125.348 357.516 124.956 357.638 124.487C357.779 123.93 358.009 123.505 358.184 123.235C356.909 123.195 355.629 123.158 354.353 123.117L354.357 123.11Z",
    fill: "url(#paint30_linear_236_26657)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "hard-light"
    },
    opacity: 0.2,
    d: "M354.057 133.033C354.077 133.424 354.428 133.705 354.539 133.792C354.671 133.897 354.928 134.099 355.299 134.099C355.643 134.099 355.883 133.921 356.028 133.813C356.156 133.715 356.527 133.441 356.554 133.046C356.592 132.53 356.035 131.926 355.309 131.922C354.59 131.919 354.026 132.516 354.053 133.036L354.057 133.033Z",
    fill: "url(#paint31_linear_236_26657)"
  }), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M360.287 141.234C359.052 141.383 357.648 141.481 356.102 141.474C354.505 141.467 353.061 141.349 351.795 141.184C352.102 141.636 352.878 142.645 354.293 143.205C354.721 143.374 356.443 144.056 358.228 143.219C359.474 142.635 360.078 141.629 360.287 141.234Z",
    fill: "#E25F32"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M361.029 137.999C359.639 138.255 357.931 138.461 355.973 138.458C353.972 138.454 352.226 138.231 350.816 137.961C351.133 138.491 352.037 139.831 353.803 140.564C354.272 140.76 356.361 141.627 358.521 140.581C360.104 139.814 360.81 138.464 361.026 137.999H361.029Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M350.466 137.442C350.54 137.431 350.601 137.428 350.628 137.428C351.121 137.421 352.585 137.502 352.585 137.502C353.73 137.567 353.797 137.185 354.601 137.337C355.198 137.448 355.644 137.752 355.924 137.989C356.2 137.766 356.646 137.472 357.24 137.364C358.043 137.215 358.104 137.59 359.255 137.536C359.255 137.536 360.693 137.469 361.213 137.482C361.24 137.482 361.297 137.482 361.375 137.496C361.537 137.523 361.668 137.577 361.766 137.631C361.658 137.712 361.486 137.837 361.267 137.972C360.963 138.154 360.052 138.664 357.672 138.941C357.243 138.992 356.643 139.049 355.917 139.073C355.191 139.039 354.59 138.979 354.162 138.924C351.786 138.624 350.881 138.107 350.577 137.921C350.354 137.786 350.186 137.658 350.081 137.577C350.179 137.526 350.31 137.472 350.472 137.448L350.466 137.442Z",
    fill: "#E05F3A"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M338.5 104.687C338.949 102.294 339.617 100.165 340.359 98.3185C341.784 97.9708 344.055 97.3802 346.803 96.4791C352.031 94.7646 352.848 93.9478 355.606 93.7318C357.03 93.6204 361.816 93.2424 364.385 96.3474C365.296 97.4511 365.651 98.6627 365.809 99.4727C367.406 99.2803 369.748 99.3175 371.807 100.644C375.27 102.878 376.739 108.008 374.703 112.915C374.703 112.919 374.703 112.926 374.703 112.929C374.727 114.61 374.457 116.037 374.008 118.43C373.434 121.485 372.725 123.972 372.168 125.717C372.027 125.734 371.882 125.757 371.74 125.805C371.588 125.855 371.21 126.058 370.771 126.419C371.099 122.625 370.508 120.374 369.87 119.001C369.667 118.562 369.067 117.374 368.516 115.626C368.169 114.525 367.966 113.601 367.848 112.983C369.519 111.37 369.698 110.715 369.529 110.418C369.502 110.371 369.455 110.344 369.411 110.313C368.614 111.052 367.426 112.028 365.83 112.919C360.348 115.97 354.87 115.298 352.463 115.005C350.128 114.718 348.683 114.184 347.697 113.725C346.354 113.098 345.341 112.365 344.656 111.802C344.528 113.594 344.329 114.991 344.163 115.963C344.059 116.581 343.968 117.023 343.846 117.499C343.509 118.822 343.083 119.736 343.013 119.973C342.58 121.377 342.213 123.456 342.594 126.281C342.321 126.004 342.01 125.781 341.645 125.656C341.554 125.626 341.463 125.602 341.372 125.582C341.315 125.572 341.264 125.565 341.227 125.558C341.143 125.548 341.075 125.538 341.021 125.535C339.289 121.448 336.795 113.773 338.496 104.68L338.5 104.687ZM367.264 100.249C367.44 100.269 367.635 100.306 367.865 100.397C368.145 100.509 368.375 100.671 368.678 100.86C368.871 100.981 369.1 101.14 369.401 101.39C370.194 102.048 371.092 102.79 371.682 103.705C371.686 103.708 371.689 103.712 371.693 103.719C374.045 106.699 374.555 110.357 374.666 112.129C374.865 110.971 374.943 109.497 374.562 107.829C374.302 106.685 373.606 103.634 370.626 101.552C369.222 100.573 367.767 100.127 366.555 99.9283C366.792 100.026 367.028 100.134 367.261 100.246L367.264 100.249Z",
    fill: "url(#paint32_linear_236_26657)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M340.943 124.092C341.176 123.863 341.551 123.863 341.783 124.092L343.093 125.409C344.052 123.583 346.161 122.317 348.602 122.324C351.633 122.334 354.144 124.308 354.562 126.864L358.495 126.877C358.93 124.325 361.455 122.368 364.486 122.378C366.92 122.385 369.019 123.664 369.967 125.486L371.267 124.197C371.5 123.968 371.875 123.968 372.107 124.197C372.337 124.43 372.337 124.805 372.107 125.038L370.413 126.718C370.477 127.032 370.514 127.353 370.511 127.684C370.501 130.6 367.784 132.963 364.452 132.953C361.239 132.943 358.609 130.722 358.437 127.947L354.613 127.934C354.424 130.708 351.781 132.909 348.565 132.899C345.233 132.889 342.533 130.506 342.543 127.589C342.543 127.265 342.58 126.948 342.644 126.637L340.94 124.923C340.707 124.69 340.71 124.315 340.94 124.082L340.943 124.092ZM359.369 127.657C359.362 130.053 361.641 132.011 364.452 132.021C367.264 132.031 369.556 130.087 369.566 127.691C369.573 125.294 367.294 123.336 364.483 123.326C361.671 123.316 359.379 125.26 359.369 127.657ZM343.481 127.603C343.475 129.999 345.753 131.957 348.565 131.967C351.376 131.977 353.668 130.033 353.678 127.637C353.685 125.24 351.407 123.282 348.595 123.272C345.783 123.262 343.491 125.206 343.481 127.603Z",
    fill: "#6F5EAB"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M356.577 183.166C369.377 183.166 381.413 178.181 390.462 169.132C399.515 160.08 404.497 148.048 404.497 135.25C404.497 122.452 399.512 110.417 390.462 101.368C381.413 92.3199 369.377 87.335 356.577 87.335C343.778 87.335 331.742 92.3199 322.693 101.368C313.643 110.42 308.658 122.452 308.658 135.25C308.658 148.048 313.643 160.08 322.693 169.132C331.745 178.181 343.778 183.166 356.577 183.166ZM356.577 88.0876C369.177 88.0876 381.021 92.9949 389.929 101.902C398.836 110.808 403.744 122.651 403.744 135.25C403.744 147.849 398.836 159.692 389.929 168.599C381.021 177.506 369.177 182.413 356.577 182.413C343.977 182.413 332.133 177.506 323.226 168.599C314.318 159.692 309.411 147.849 309.411 135.25C309.411 122.651 314.318 110.808 323.226 101.902C332.133 92.9949 343.977 88.0876 356.577 88.0876Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M582.124 309.535C555.823 309.535 534.493 288.285 534.484 262.073C534.474 235.86 555.788 214.611 582.09 214.611C608.392 214.611 629.721 235.86 629.731 262.073C629.74 288.285 608.426 309.535 582.124 309.535Z",
    fill: "#3B73F0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_236_26657",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 534,
    y: 214,
    width: 96,
    height: 96
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M582.124 309.535C555.823 309.535 534.493 288.285 534.484 262.073C534.474 235.86 555.788 214.611 582.09 214.611C608.392 214.611 629.721 235.86 629.731 262.073C629.74 288.285 608.426 309.535 582.124 309.535Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_236_26657)"
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M564.985 240.791C564.556 246.063 564.549 250.356 564.627 253.323C564.833 261.436 565.747 263.353 564.215 267.086C563.216 269.516 561.889 270.994 562.038 273.786C562.176 276.347 563.462 278.241 564.097 279.149C566.254 282.237 569.204 283.489 571.236 284.349C575.664 286.223 579.603 286.148 582.199 286.094C583.08 286.074 585.763 285.969 589.182 285.126C592.649 284.268 597.621 283.04 600.945 279.01C602.559 277.053 603.045 275.284 603.217 274.474C603.389 273.674 603.635 272.456 603.234 271.075C602.778 269.503 601.765 268.699 601.185 268.031C599.18 265.723 600.483 262.098 600.095 259.337C599.531 255.317 599.173 249.421 600.233 241.547C597.087 234.855 590.458 230.46 583.1 230.207C575.56 229.944 568.495 234.072 564.978 240.788L564.985 240.791Z",
    fill: "url(#paint33_linear_236_26657)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M593.097 262.739C592.695 264.724 592.28 267.643 592.435 271.173C592.506 272.756 592.608 275.051 593.229 276.951C595.095 282.676 601.974 285.828 605.062 287.033C597.367 291.798 589.668 296.56 581.972 301.326C574.32 296.5 566.668 291.677 559.016 286.85C562.55 285.521 569.416 282.372 571.087 276.796C571.583 275.139 571.647 273.171 571.718 271.109C571.839 267.458 571.475 264.437 571.117 262.351C578.441 262.479 585.769 262.611 593.094 262.739H593.097Z",
    fill: "url(#paint34_linear_236_26657)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M542.106 297.284C542.443 296.646 542.953 295.512 544.043 294.256C545.137 292.994 546.375 292.046 547.864 291.175C550.659 289.545 557.284 286.463 566.293 282.933C569.034 288.792 575.207 292.66 582.066 292.819C589.036 292.977 595.49 289.275 598.463 283.406C601.376 284.864 603.779 285.927 605.369 286.605C610.456 288.775 614.429 290.065 618.023 293.227C618.567 293.703 618.941 294.081 619.022 294.169C621.551 296.801 622.624 299.559 623.211 301.111C624.578 304.722 624.71 307.898 624.632 309.862C613.7 312.606 598.99 315.175 581.536 315.121C564.585 315.067 550.264 312.556 539.527 309.862C539.395 306.815 539.638 301.935 542.102 297.287L542.106 297.284Z",
    fill: "#37A4A9"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M573.436 231.551C578.192 228.53 584.42 229.037 588.791 231.267C592.645 233.238 594.539 236.286 595.285 237.521C598.863 243.455 597.725 249.722 596.594 256.02C595.46 262.328 593.455 265.922 592.703 267.188C592.355 267.772 588.642 273.854 584.548 274.61C583.339 274.832 581.959 274.839 581.959 274.839C581.959 274.839 579.92 274.853 578.131 274.39C574.466 273.449 571.769 268.508 570.804 266.658C570.027 265.17 568.424 261.818 567.381 256.155C566.304 250.313 565.393 245.304 567.577 239.631C568.464 237.329 569.798 233.866 573.44 231.551H573.436Z",
    fill: "url(#paint35_linear_236_26657)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M569.467 224.211C567.658 228.085 569.197 232.632 572.91 234.366C576.619 236.098 581.095 234.363 582.907 230.489C584.717 226.614 583.177 222.068 579.465 220.333C575.755 218.602 571.279 220.336 569.47 224.211H569.467Z",
    fill: "url(#paint36_linear_236_26657)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M567.296 251.484C567.205 251.379 566.969 251.133 566.571 251.025C566.253 250.937 565.987 250.977 565.852 251.008C565.491 249.732 565.004 247.842 564.593 245.517C563.931 241.77 563.56 239.671 563.985 236.87C564.056 236.397 564.593 233.053 566.419 230.359C566.469 230.282 566.52 230.211 566.527 230.204C566.955 229.59 568.204 227.936 570.402 226.383C575.414 222.846 584.146 220.565 591.636 224.554C592.864 225.209 597.58 227.686 599.568 232.934C600.753 236.063 600.486 238.912 600.24 241.554C599.855 245.699 598.626 248.942 597.674 250.981C597.519 250.991 597.327 251.018 597.121 251.089C596.753 251.214 596.435 251.436 596.159 251.713C596.054 250.616 595.926 248.935 595.919 246.877C595.686 245.189 596.246 243.964 595.501 240.997C594.994 238.982 593.361 236.62 592.5 236.849C587.731 237.875 586.107 238.088 582.57 238.017C578.442 237.933 576.852 237.464 571.931 236.255C569.652 235.699 568.835 240.164 568.535 241.22C568.211 242.368 568.255 243.002 568.133 244.811C568.029 246.384 567.809 248.669 567.3 251.48L567.296 251.484Z",
    fill: "url(#paint37_linear_236_26657)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M585.763 226.09C586.141 226.198 588.227 226.843 588.959 228.716C589.894 231.106 587.846 233.485 587.356 234.052C585.307 236.435 582.259 236.793 580.022 237.059C577.372 237.377 575.195 237.032 573.875 236.732C574.861 237.177 580.97 239.837 586.175 236.995C587.025 236.533 589.418 235.227 590.404 232.544C590.677 231.804 591.265 230.198 590.505 228.581C589.834 227.154 588.497 226.549 588.156 226.408C587.13 225.982 586.209 226.036 585.766 226.09H585.763Z",
    fill: "url(#paint38_linear_236_26657)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M584.332 222.491C584.734 222.534 585.139 222.578 585.54 222.622C588.551 222.052 591.376 223.095 592.632 225.167C594.151 227.671 592.757 230.655 592.399 231.411C590.86 234.698 587.326 236.308 585.031 237.354C584.356 237.661 583.782 237.881 583.377 238.026C584.514 238.043 586.263 237.925 588.2 237.175C588.804 236.942 595.163 234.374 595.403 229.308C595.498 227.297 594.586 225.791 594.262 225.278C592.872 223.058 590.381 221.731 587.883 221.681C586.276 221.65 585.017 222.153 584.325 222.491H584.332Z",
    fill: "url(#paint39_linear_236_26657)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M600.327 253.503C600.935 256.672 597.63 261.725 596.014 260.881C595.116 260.412 594.809 258.167 594.805 256.824C594.798 254.721 595.524 251.822 597.121 251.123C598.494 250.522 600 251.778 600.327 253.503Z",
    fill: "url(#paint40_linear_236_26657)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M599.311 254.363C599.595 256.074 598.447 258.477 597.421 258.238C596.763 258.082 596.138 256.834 596.257 255.318C596.361 253.958 597.023 252.918 597.742 252.759C598.457 252.601 599.139 253.33 599.311 254.363Z",
    fill: "url(#paint41_radial_236_26657)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M597.38 255.369C597.637 256.196 597.289 257.644 596.807 257.711C596.496 257.755 596.118 257.229 596.061 256.429C596.01 255.71 596.233 255.051 596.55 254.835C596.864 254.619 597.229 254.869 597.38 255.365V255.369Z",
    fill: "url(#paint42_linear_236_26657)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M563.715 253.503C563.114 256.672 566.425 261.725 568.042 260.881C568.94 260.412 569.241 258.167 569.244 256.824C569.244 254.721 568.515 251.822 566.918 251.123C565.541 250.522 564.043 251.778 563.715 253.503Z",
    fill: "url(#paint43_linear_236_26657)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M564.731 254.363C564.451 256.074 565.606 258.477 566.628 258.238C567.287 258.082 567.908 256.834 567.789 255.318C567.681 253.958 567.016 252.918 566.298 252.759C565.582 252.601 564.9 253.33 564.731 254.363Z",
    fill: "url(#paint44_radial_236_26657)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M566.665 255.369C566.412 256.196 566.763 257.644 567.245 257.711C567.556 257.755 567.931 257.229 567.988 256.429C568.039 255.71 567.813 255.051 567.495 254.835C567.181 254.619 566.817 254.869 566.665 255.365V255.369Z",
    fill: "url(#paint45_linear_236_26657)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M585.091 253.581H591.956L591.95 247.137H585.084L585.091 253.581Z",
    fill: "url(#paint46_radial_236_26657)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M571.287 247.137H578.152V253.581H571.287V247.137Z",
    fill: "url(#paint47_radial_236_26657)"
  }), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M587.596 251.856C587.596 252.855 588.102 253.661 588.727 253.661C589.348 253.661 589.854 252.851 589.851 251.856C589.851 250.857 589.344 250.05 588.723 250.05C588.102 250.05 587.596 250.86 587.599 251.856H587.596Z",
    fill: "url(#paint48_linear_236_26657)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M573.379 251.856C573.379 252.855 573.885 253.661 574.509 253.661C575.13 253.661 575.637 252.851 575.633 251.856C575.633 250.857 575.127 250.05 574.503 250.05C573.882 250.05 573.375 250.86 573.379 251.856Z",
    fill: "url(#paint49_linear_236_26657)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M593.577 248.433C593.817 247.704 591.933 245.99 589.915 245.656C587.572 245.267 585.115 246.58 584.943 247.424C584.902 247.826 585.189 247.934 585.284 247.971C585.446 248.032 585.605 247.984 585.743 247.924C585.891 247.86 586.023 247.768 586.107 247.714C586.246 247.627 586.438 247.515 586.671 247.404C586.86 247.313 587.238 247.137 587.724 247.026C588.436 246.864 589.024 246.928 589.355 246.968C589.5 246.985 590.063 247.06 590.752 247.326C591.079 247.455 591.494 247.613 591.957 247.941C592.288 248.177 592.922 248.693 593.199 248.68C593.199 248.68 593.486 248.673 593.574 248.43L593.577 248.433Z",
    fill: "url(#paint50_linear_236_26657)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M569.785 248.433C569.542 247.704 571.422 245.99 573.44 245.656C575.783 245.267 578.24 246.58 578.415 247.424C578.456 247.826 578.172 247.934 578.078 247.971C577.916 248.032 577.757 247.984 577.615 247.924C577.467 247.86 577.335 247.768 577.251 247.714C577.112 247.627 576.923 247.515 576.687 247.404C576.498 247.313 576.12 247.137 575.634 247.026C574.922 246.864 574.334 246.928 574.004 246.968C573.859 246.985 573.295 247.06 572.606 247.326C572.279 247.455 571.867 247.613 571.405 247.944C571.074 248.18 570.443 248.697 570.163 248.683C570.163 248.683 569.876 248.676 569.788 248.433H569.785Z",
    fill: "url(#paint51_linear_236_26657)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M579.67 248.483C579.819 248.78 580.011 249.242 580.112 249.826C580.214 250.427 580.173 250.893 580.146 251.193C579.896 253.863 579.525 255.658 579.403 256.212C579.322 256.593 579.204 257.13 578.934 257.795C578.755 258.237 578.57 258.591 578.435 258.824C578.421 258.999 578.425 259.266 578.529 259.56C578.742 260.164 579.228 260.474 579.542 260.673C579.792 260.832 580.49 261.264 581.469 261.217C583.008 261.143 583.866 259.938 583.98 259.772C584.119 259.573 584.206 259.391 584.26 259.263C584.21 259.077 584.122 258.773 584.024 258.402C583.41 256.07 583.241 254.477 582.907 251.291C582.877 250.99 582.819 250.413 583.008 249.711C583.143 249.219 583.349 248.837 583.518 248.577C582.235 248.544 580.953 248.51 579.673 248.476L579.67 248.483Z",
    fill: "url(#paint52_linear_236_26657)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "hard-light"
    },
    opacity: 0.3,
    d: "M579.751 258.091C579.775 258.567 580.156 258.898 580.278 259.003C580.419 259.128 580.7 259.371 581.105 259.367C581.479 259.364 581.739 259.148 581.894 259.016C582.033 258.898 582.435 258.564 582.462 258.088C582.499 257.463 581.888 256.738 581.105 256.738C580.322 256.738 579.717 257.46 579.751 258.088V258.091Z",
    fill: "url(#paint53_linear_236_26657)"
  }), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M585.733 266.607C584.494 266.759 583.083 266.867 581.534 266.867C579.931 266.867 578.479 266.759 577.21 266.597C577.521 267.049 578.307 268.055 579.728 268.608C580.157 268.777 581.892 269.449 583.681 268.605C584.929 268.014 585.53 267.002 585.736 266.607H585.733Z",
    fill: "#E67B52"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M586.458 263.363C585.067 263.627 583.349 263.843 581.385 263.846C579.373 263.853 577.621 263.64 576.207 263.373C576.528 263.9 577.446 265.24 579.221 265.966C579.694 266.158 581.797 267.019 583.96 265.962C585.543 265.186 586.245 263.832 586.461 263.363H586.458Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M575.846 262.858C575.921 262.848 575.981 262.844 576.008 262.844C576.501 262.838 577.973 262.909 577.973 262.909C579.124 262.966 579.188 262.584 579.995 262.733C580.595 262.844 581.044 263.145 581.328 263.378C581.605 263.152 582.047 262.858 582.644 262.746C583.448 262.594 583.515 262.969 584.67 262.909C584.67 262.909 586.111 262.834 586.634 262.844C586.661 262.844 586.718 262.844 586.796 262.858C586.958 262.881 587.093 262.939 587.188 262.99C587.079 263.071 586.911 263.196 586.688 263.331C586.384 263.517 585.473 264.033 583.086 264.32C582.654 264.371 582.054 264.432 581.325 264.462C580.595 264.435 579.991 264.375 579.563 264.32C577.176 264.033 576.262 263.517 575.958 263.331C575.735 263.196 575.563 263.071 575.455 262.99C575.553 262.939 575.684 262.881 575.846 262.858Z",
    fill: "#E47B59"
  }))), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M582.081 310C594.88 310 606.913 305.015 615.965 295.966C625.018 286.914 630 274.882 630 262.084C630 249.286 625.015 237.251 615.965 228.202C606.913 219.154 594.88 214.169 582.081 214.169C569.281 214.169 557.245 219.154 548.196 228.202C539.143 237.254 534.161 249.286 534.161 262.084C534.161 274.882 539.147 286.914 548.196 295.966C557.245 305.015 569.281 310 582.081 310ZM582.081 214.922C594.681 214.922 606.525 219.829 615.432 228.736C624.34 237.642 629.247 249.485 629.247 262.084C629.247 274.683 624.34 286.526 615.432 295.433C606.525 304.34 594.681 309.247 582.081 309.247C569.481 309.247 557.636 304.34 548.729 295.433C539.822 286.526 534.914 274.683 534.914 262.084C534.914 249.485 539.822 237.642 548.729 228.736C557.636 219.829 569.481 214.922 582.081 214.922Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M243.503 78.7233L242.273 78.2585C241.501 77.9723 241.103 77.1 241.385 76.3152C241.55 75.8505 241.918 75.5204 242.349 75.3857C242.767 75.2173 243.258 75.2409 243.672 75.4935C244.378 75.9245 244.604 76.8575 244.18 77.5748L243.5 78.7233H243.503Z",
    fill: "#5B8AEB"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M56.459 210.877C55.6368 210.877 54.9704 210.2 54.967 209.365V209.19C54.967 208.354 55.6368 207.677 56.459 207.677H56.4624C57.2879 207.677 57.951 208.361 57.951 209.196V209.355C57.951 210.193 57.2879 210.873 56.4624 210.873H56.459V210.877ZM56.658 203.33C56.6314 203.33 56.6082 203.33 56.5817 203.33C55.7595 203.289 55.1262 202.575 55.166 201.74L55.1759 201.569C55.219 200.733 55.9219 200.09 56.7442 200.137C57.5664 200.181 58.1997 200.895 58.1533 201.73L58.1433 201.892C58.1036 202.703 57.4438 203.33 56.6547 203.33H56.658ZM57.2349 195.806C57.1818 195.806 57.1321 195.806 57.0791 195.8C56.2601 195.712 55.6633 194.968 55.7495 194.136L55.7661 193.971C55.8523 193.139 56.5817 192.536 57.404 192.621C58.2229 192.708 58.8197 193.452 58.7335 194.284L58.7169 194.449C58.6374 195.227 57.9908 195.81 57.2349 195.81V195.806ZM58.1898 188.323C58.1135 188.323 58.0372 188.317 57.9577 188.307C57.142 188.179 56.585 187.404 56.711 186.576L56.7375 186.407C56.8669 185.579 57.6294 185.016 58.4451 185.148C59.2607 185.279 59.8144 186.054 59.6851 186.882L59.6619 187.044C59.5491 187.791 58.9126 188.327 58.1898 188.327V188.323ZM59.5193 180.901C59.4198 180.901 59.3204 180.891 59.2176 180.871C58.4086 180.702 57.8914 179.901 58.0538 179.083L58.0903 178.911C58.2594 178.093 59.0518 177.567 59.8575 177.739C60.6632 177.911 61.1804 178.716 61.0113 179.534L60.9781 179.689C60.8323 180.406 60.2123 180.901 59.5193 180.901ZM61.2235 173.556C61.1008 173.556 60.9748 173.539 60.8488 173.509C60.0498 173.3 59.5724 172.472 59.7779 171.664L59.821 171.492C60.0332 170.684 60.8488 170.202 61.6446 170.414C62.4403 170.63 62.9144 171.458 62.7056 172.266L62.6658 172.421C62.49 173.105 61.8866 173.556 61.2235 173.556ZM63.3024 166.309C63.1532 166.309 63.004 166.286 62.8548 166.238C62.069 165.986 61.6313 165.137 61.88 164.339L61.933 164.171C62.185 163.372 63.0272 162.935 63.8096 163.194C64.5954 163.45 65.0264 164.305 64.7712 165.1L64.7247 165.252C64.5258 165.898 63.9356 166.312 63.3024 166.312V166.309ZM65.7492 159.183C65.5735 159.183 65.3945 159.153 65.2221 159.085C64.4529 158.789 64.0616 157.914 64.3534 157.132L64.4131 156.977C64.7048 156.196 65.5636 155.799 66.3361 156.095C67.1053 156.391 67.4965 157.267 67.2048 158.048L67.1451 158.203C66.9196 158.809 66.3527 159.183 65.7492 159.183ZM68.5575 152.195C68.3586 152.195 68.153 152.155 67.9574 152.067C67.2015 151.73 66.86 150.838 67.1915 150.07L67.2578 149.915C67.5894 149.151 68.4713 148.801 69.224 149.141C69.9766 149.478 70.3214 150.373 69.9865 151.138L69.9202 151.289C69.6749 151.858 69.1278 152.195 68.5542 152.195H68.5575ZM71.7239 145.366C71.4984 145.366 71.2696 145.315 71.0541 145.204C70.3181 144.827 70.023 143.918 70.391 143.17L70.4673 143.018C70.8386 142.271 71.7371 141.971 72.4732 142.348C73.2093 142.725 73.5043 143.638 73.133 144.386L73.0601 144.534C72.7981 145.062 72.271 145.369 71.7272 145.369L71.7239 145.366ZM75.2417 138.714C74.9897 138.714 74.7377 138.65 74.5023 138.516C73.7862 138.102 73.5375 137.175 73.9486 136.448L74.0315 136.3C74.4426 135.572 75.3511 135.323 76.0673 135.737C76.7834 136.155 77.0288 137.081 76.621 137.805L76.5414 137.95C76.2662 138.438 75.7622 138.714 75.245 138.714H75.2417ZM79.1043 132.262C78.8258 132.262 78.5473 132.185 78.2953 132.02C77.6024 131.565 77.4034 130.629 77.851 129.925L77.9439 129.78C78.3915 129.08 79.3165 128.878 80.0062 129.336C80.6958 129.79 80.8947 130.73 80.4438 131.43L80.3576 131.568C80.0725 132.016 79.5917 132.262 79.101 132.262H79.1043ZM83.3018 126.028C83.0001 126.028 82.6951 125.934 82.4298 125.742C81.7601 125.254 81.6109 124.304 82.0916 123.627L82.1911 123.486C82.6752 122.809 83.6102 122.657 84.2766 123.152C84.943 123.644 85.0889 124.594 84.6048 125.271L84.512 125.402C84.2202 125.813 83.7627 126.032 83.3018 126.032V126.028ZM87.8242 120.034C87.4927 120.034 87.1611 119.923 86.8826 119.694C86.2427 119.165 86.1466 118.212 86.6671 117.562L86.7699 117.434C87.2871 116.784 88.2287 116.683 88.8686 117.212C89.5085 117.737 89.608 118.694 89.0875 119.344L88.9814 119.478C88.6863 119.845 88.2553 120.037 87.8242 120.037V120.034ZM92.6583 114.299C92.3036 114.299 91.9455 114.171 91.6603 113.908C91.047 113.349 91.0006 112.389 91.5509 111.766L91.667 111.638C92.2207 111.019 93.1656 110.972 93.7757 111.537C94.3857 112.1 94.4322 113.06 93.8751 113.679L93.769 113.8C93.474 114.134 93.0695 114.302 92.6616 114.302L92.6583 114.299ZM97.7975 108.84C97.4128 108.84 97.0249 108.688 96.7332 108.389C96.1562 107.793 96.1629 106.833 96.7497 106.247L96.8658 106.132C97.4526 105.543 98.3976 105.55 98.9745 106.146C99.5547 106.742 99.5481 107.702 98.9612 108.288L98.8419 108.409C98.5501 108.698 98.1721 108.843 97.7941 108.843L97.7975 108.84ZM103.225 103.674C102.811 103.674 102.399 103.499 102.104 103.159C101.561 102.529 101.62 101.573 102.24 101.02L102.36 100.912C102.976 100.357 103.918 100.414 104.465 101.04C105.012 101.667 104.956 102.623 104.339 103.179L104.21 103.293C103.928 103.546 103.576 103.671 103.225 103.671V103.674ZM108.924 98.8211C108.484 98.8211 108.046 98.6224 107.751 98.2419C107.24 97.5852 107.353 96.6321 107.999 96.1135L108.129 96.0091C108.775 95.4905 109.714 95.605 110.224 96.2617C110.735 96.9184 110.622 97.8714 109.976 98.3901L109.846 98.4945C109.574 98.7134 109.246 98.8178 108.924 98.8178V98.8211ZM114.883 94.2984C114.415 94.2984 113.954 94.0761 113.662 93.6585C113.188 92.9749 113.347 92.0286 114.02 91.547L114.16 91.4493C114.833 90.9677 115.764 91.1328 116.239 91.8198C116.713 92.5034 116.55 93.4497 115.874 93.9313L115.741 94.0256C115.479 94.2142 115.181 94.3017 114.883 94.3017V94.2984ZM121.079 90.1191C120.582 90.1191 120.098 89.8665 119.813 89.4085C119.375 88.6979 119.587 87.7651 120.287 87.3206L120.433 87.2296C121.132 86.7885 122.054 87.0074 122.488 87.7179C122.923 88.4285 122.707 89.3647 122.008 89.8059L121.872 89.8935C121.626 90.0484 121.351 90.1258 121.083 90.1258L121.079 90.1191ZM127.495 86.3002C126.968 86.3002 126.46 86.0173 126.189 85.5155C125.791 84.7813 126.053 83.862 126.775 83.4579L126.925 83.3737C127.647 82.9729 128.556 83.2423 128.95 83.9765C129.345 84.7106 129.08 85.6334 128.357 86.0341L128.218 86.1116C127.989 86.2395 127.74 86.3002 127.498 86.3002H127.495ZM134.109 82.8584C133.552 82.8584 133.019 82.5385 132.763 81.9963C132.409 81.2419 132.724 80.336 133.466 79.9757L133.619 79.9016C134.361 79.5413 135.253 79.8646 135.608 80.6189C135.963 81.3733 135.645 82.2792 134.902 82.6395L134.756 82.7102C134.547 82.8113 134.328 82.8584 134.113 82.8584H134.109ZM140.91 79.8073C140.323 79.8073 139.766 79.4537 139.527 78.8644C139.215 78.0898 139.58 77.2041 140.343 76.8875L140.499 76.8236C141.261 76.507 142.133 76.8808 142.441 77.6587C142.753 78.4333 142.385 79.319 141.619 79.6322L141.47 79.6928C141.284 79.7703 141.092 79.8073 140.906 79.8073H140.91ZM147.869 77.157C147.249 77.157 146.669 76.7596 146.457 76.1298C146.191 75.3384 146.606 74.4763 147.385 74.2069L147.541 74.153C148.32 73.8836 149.169 74.3045 149.434 75.0959C149.699 75.8873 149.285 76.7495 148.506 77.0189L148.35 77.0728C148.191 77.1266 148.028 77.1536 147.866 77.1536L147.869 77.157ZM235.891 76.0524C235.751 76.0524 235.609 76.0322 235.466 75.9884L235.314 75.9412C234.521 75.7055 234.067 74.8669 234.299 74.0621C234.531 73.2572 235.36 72.7958 236.149 73.0316L236.312 73.0787C237.101 73.3144 237.552 74.1597 237.32 74.9612C237.127 75.6213 236.534 76.049 235.891 76.049V76.0524ZM154.968 74.9107C154.314 74.9107 153.718 74.4729 153.532 73.8061C153.31 73.0013 153.771 72.1627 154.563 71.9371L154.729 71.8899C155.521 71.6643 156.344 72.1391 156.566 72.944C156.785 73.7522 156.32 74.5874 155.528 74.8097L155.375 74.8535C155.24 74.8905 155.104 74.9107 154.971 74.9107H154.968ZM228.706 74.1126C228.59 74.1126 228.474 74.0991 228.358 74.0722L228.202 74.0351C227.399 73.8432 226.902 73.0282 227.091 72.2132C227.28 71.3983 228.082 70.8931 228.885 71.0851L229.051 71.1255C229.853 71.3208 230.347 72.1391 230.155 72.9507C229.992 73.6445 229.379 74.1126 228.706 74.1126ZM162.179 73.0787C161.496 73.0787 160.879 72.5971 160.723 71.8933C160.544 71.075 161.052 70.2667 161.857 70.0849L162.023 70.0478C162.826 69.866 163.625 70.3846 163.8 71.2029C163.976 72.0213 163.469 72.8295 162.663 73.008L162.504 73.045C162.395 73.0686 162.285 73.0821 162.179 73.0821V73.0787ZM221.431 72.5365C221.339 72.5365 221.246 72.5264 221.153 72.5096L220.99 72.4793C220.181 72.3244 219.648 71.533 219.8 70.7112C219.953 69.8895 220.732 69.3473 221.541 69.5023L221.707 69.5326C222.516 69.6875 223.049 70.4789 222.897 71.304C222.761 72.0314 222.134 72.5399 221.431 72.5399V72.5365ZM169.48 71.6542C168.764 71.6542 168.13 71.1255 168.008 70.3846C167.875 69.5595 168.426 68.7782 169.238 68.6435L169.4 68.6166C170.216 68.4819 170.982 69.0409 171.114 69.866C171.247 70.691 170.697 71.4723 169.884 71.607L169.722 71.634C169.639 71.6475 169.559 71.6542 169.48 71.6542ZM214.094 71.3107C214.024 71.3107 213.955 71.3073 213.885 71.2972L213.716 71.2736C212.9 71.1558 212.333 70.388 212.45 69.5595C212.566 68.7311 213.322 68.1552 214.137 68.2731L214.296 68.2966C215.112 68.4111 215.682 69.179 215.569 70.0074C215.467 70.7651 214.827 71.3141 214.094 71.3141V71.3107ZM176.847 70.6338C176.094 70.6338 175.448 70.0579 175.365 69.2834C175.275 68.4515 175.866 67.7039 176.685 67.613L176.85 67.5962C177.669 67.5019 178.405 68.1047 178.495 68.9365C178.584 69.7683 177.994 70.5159 177.175 70.6069L177.01 70.6237C176.953 70.6304 176.9 70.6338 176.844 70.6338H176.847ZM206.71 70.4385C206.664 70.4385 206.617 70.4385 206.574 70.4317L206.405 70.4149C205.586 70.3374 204.983 69.5966 205.059 68.7647C205.135 67.9329 205.862 67.32 206.684 67.3975L206.843 67.4109C207.665 67.4884 208.269 68.2259 208.192 69.0577C208.123 69.8458 207.47 70.4351 206.707 70.4351L206.71 70.4385ZM184.257 70.0108C183.475 70.0108 182.815 69.3911 182.769 68.5863C182.719 67.7511 183.349 67.0338 184.171 66.9832L184.34 66.9731C185.162 66.9294 185.865 67.5658 185.912 68.401C185.958 69.2362 185.328 69.9535 184.506 69.9973L184.347 70.0074C184.317 70.0074 184.287 70.0074 184.257 70.0074V70.0108ZM199.29 69.9232C199.267 69.9232 199.247 69.9232 199.224 69.9232L199.065 69.9165C198.242 69.8828 197.602 69.1756 197.636 68.3404C197.669 67.5052 198.368 66.862 199.187 66.8889L199.356 66.8957C200.179 66.9327 200.819 67.6399 200.782 68.4751C200.746 69.2901 200.086 69.9232 199.293 69.9232H199.29ZM191.691 69.775C190.872 69.775 190.205 69.1015 190.199 68.2697C190.195 67.4311 190.859 66.7509 191.681 66.7441H191.847C191.847 66.7441 191.853 66.7441 191.857 66.7441C192.676 66.7441 193.342 67.4177 193.349 68.2495C193.352 69.088 192.689 69.7683 191.867 69.775H191.701C191.701 69.775 191.694 69.775 191.691 69.775Z",
    fill: "#5B8AEB"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2683 219.63L55.149 216.936C55.1025 216.114 55.7126 215.393 56.515 215.326C57.0587 215.262 57.6157 215.494 57.9373 215.986C58.3949 216.683 58.2192 217.616 57.5329 218.081L55.265 219.627L55.2683 219.63Z",
    fill: "#5B8AEB"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M241.944 258.453C241.457 258.453 240.976 258.21 240.691 257.762L240.598 257.617C240.151 256.914 240.346 255.977 241.039 255.523C241.732 255.068 242.654 255.267 243.102 255.971L243.191 256.112C243.639 256.813 243.443 257.752 242.753 258.207C242.501 258.372 242.22 258.453 241.941 258.453H241.944ZM237.667 252.142C237.207 252.142 236.752 251.926 236.46 251.519L236.364 251.384C235.877 250.71 236.02 249.761 236.686 249.266C237.349 248.771 238.284 248.915 238.771 249.592L238.871 249.734C239.358 250.411 239.212 251.357 238.546 251.852C238.281 252.047 237.972 252.145 237.667 252.145V252.142ZM233.055 246.083C232.624 246.083 232.193 245.895 231.898 245.527L231.796 245.399C231.272 244.753 231.364 243.797 232.004 243.268C232.641 242.739 233.583 242.833 234.103 243.48L234.213 243.615C234.733 244.265 234.64 245.218 234 245.746C233.722 245.975 233.39 246.087 233.059 246.087L233.055 246.083ZM228.135 240.281C227.727 240.281 227.323 240.112 227.028 239.782L226.918 239.658C226.365 239.038 226.408 238.082 227.018 237.516C227.628 236.953 228.569 236.997 229.126 237.617L229.243 237.745C229.796 238.364 229.75 239.324 229.14 239.887C228.855 240.149 228.497 240.281 228.138 240.281H228.135ZM222.92 234.751C222.538 234.751 222.16 234.606 221.869 234.31L221.753 234.192C221.166 233.603 221.159 232.643 221.739 232.05C222.32 231.454 223.265 231.447 223.848 232.037L223.971 232.158C224.554 232.747 224.561 233.707 223.981 234.3C223.689 234.599 223.304 234.748 222.923 234.748L222.92 234.751ZM217.423 229.514C217.068 229.514 216.716 229.386 216.431 229.13L216.309 229.019C215.692 228.464 215.635 227.507 216.183 226.881C216.73 226.254 217.671 226.197 218.288 226.753L218.414 226.867C219.031 227.423 219.084 228.383 218.537 229.006C218.242 229.342 217.834 229.514 217.423 229.514ZM211.657 224.587C211.332 224.587 211.004 224.48 210.728 224.257L210.599 224.153C209.953 223.634 209.847 222.681 210.357 222.025C210.868 221.368 211.806 221.26 212.453 221.779L212.585 221.886C213.228 222.408 213.338 223.362 212.824 224.015C212.529 224.392 212.094 224.587 211.657 224.587ZM205.632 219.991C205.334 219.991 205.032 219.9 204.77 219.711L204.638 219.617C203.965 219.135 203.802 218.189 204.28 217.505C204.754 216.822 205.685 216.66 206.359 217.141L206.498 217.242C207.171 217.727 207.327 218.674 206.849 219.354C206.557 219.768 206.1 219.991 205.632 219.991ZM199.363 215.747C199.094 215.747 198.819 215.673 198.574 215.518L198.431 215.427C197.731 214.983 197.519 214.05 197.957 213.339C198.395 212.629 199.313 212.413 200.013 212.858L200.152 212.949C200.851 213.39 201.064 214.326 200.629 215.037C200.347 215.498 199.86 215.751 199.363 215.751V215.747ZM62.9705 214.4C62.4532 214.4 61.9493 214.127 61.6741 213.639C61.263 212.912 61.5116 211.986 62.2245 211.571L62.367 211.487C63.0799 211.07 63.9917 211.319 64.4061 212.043C64.8172 212.767 64.5719 213.693 63.859 214.114L63.7098 214.201C63.4744 214.34 63.2191 214.404 62.9672 214.404L62.9705 214.4ZM192.864 211.878C192.622 211.878 192.373 211.817 192.148 211.689L192.005 211.612C191.283 211.211 191.014 210.292 191.409 209.557C191.803 208.823 192.708 208.551 193.431 208.951L193.584 209.035C194.306 209.44 194.568 210.359 194.174 211.093C193.902 211.595 193.391 211.878 192.864 211.878ZM69.6082 210.777C69.0612 210.777 68.534 210.47 68.2721 209.938C67.904 209.19 68.2024 208.278 68.9385 207.904L69.0877 207.83C69.8237 207.456 70.7223 207.756 71.0903 208.503C71.4583 209.251 71.1632 210.164 70.4272 210.537L70.2747 210.615C70.0591 210.723 69.8337 210.777 69.6082 210.777ZM186.154 208.399C185.938 208.399 185.719 208.352 185.514 208.251L185.368 208.18C184.622 207.823 184.303 206.921 184.655 206.163C185.006 205.405 185.895 205.082 186.641 205.439L186.797 205.513C187.539 205.873 187.858 206.776 187.503 207.534C187.248 208.079 186.714 208.399 186.154 208.399ZM76.4317 207.53C75.8581 207.53 75.3077 207.19 75.0623 206.621C74.7341 205.853 75.0789 204.961 75.8315 204.627L75.9907 204.557C76.7466 204.223 77.6253 204.577 77.9535 205.348C78.2817 206.116 77.9336 207.008 77.1743 207.342L77.0251 207.406C76.8295 207.493 76.6273 207.534 76.4283 207.534L76.4317 207.53ZM179.254 205.324C179.068 205.324 178.882 205.291 178.7 205.217L178.541 205.153C177.775 204.839 177.407 203.957 177.715 203.179C178.024 202.401 178.892 202.027 179.658 202.341L179.811 202.405C180.577 202.718 180.948 203.6 180.64 204.375C180.404 204.967 179.847 205.328 179.254 205.328V205.324ZM83.4142 204.654C82.8108 204.654 82.2405 204.277 82.0184 203.671C81.7299 202.886 82.1212 202.014 82.8937 201.721L83.0528 201.66C83.8253 201.367 84.6841 201.768 84.9725 202.553C85.261 203.337 84.8664 204.21 84.0939 204.503L83.9414 204.56C83.769 204.624 83.5933 204.658 83.4175 204.658L83.4142 204.654ZM172.192 202.667C172.033 202.667 171.873 202.64 171.714 202.586L171.558 202.533C170.776 202.266 170.358 201.408 170.62 200.613C170.882 199.818 171.728 199.394 172.51 199.66L172.669 199.714C173.448 199.98 173.869 200.842 173.604 201.633C173.395 202.266 172.812 202.664 172.192 202.664V202.667ZM90.5394 202.159C89.9061 202.159 89.3192 201.745 89.117 201.101C88.8683 200.303 89.3027 199.451 90.0884 199.199L90.2476 199.148C91.0334 198.895 91.8722 199.337 92.1209 200.135C92.3696 200.933 91.9352 201.785 91.1494 202.037L90.9903 202.088C90.8411 202.135 90.6886 202.159 90.5394 202.159ZM164.99 200.434C164.861 200.434 164.725 200.418 164.592 200.381L164.433 200.337C163.638 200.115 163.17 199.283 163.389 198.475C163.604 197.666 164.427 197.191 165.222 197.414L165.385 197.461C166.181 197.683 166.648 198.518 166.429 199.323C166.247 199.997 165.647 200.438 164.99 200.438V200.434ZM97.7839 200.054C97.1207 200.054 96.514 199.599 96.3383 198.916C96.1327 198.104 96.6135 197.279 97.4125 197.07L97.5783 197.026C98.3773 196.821 99.1897 197.309 99.3919 198.121C99.5942 198.933 99.1134 199.758 98.3144 199.963L98.1552 200.003C98.0292 200.037 97.9065 200.051 97.7839 200.051V200.054ZM157.67 198.626C157.567 198.626 157.461 198.616 157.355 198.592L157.195 198.559C156.39 198.387 155.872 197.582 156.045 196.764C156.214 195.945 157.006 195.423 157.812 195.595L157.981 195.632C158.787 195.807 159.301 196.612 159.125 197.434C158.976 198.144 158.356 198.633 157.67 198.633V198.626ZM105.128 198.353C104.432 198.353 103.808 197.855 103.666 197.131C103.507 196.309 104.03 195.511 104.839 195.349L105.005 195.316C105.811 195.154 106.6 195.686 106.759 196.508C106.918 197.329 106.394 198.128 105.585 198.289L105.423 198.323C105.323 198.343 105.227 198.353 105.131 198.353H105.128ZM150.259 197.252C150.183 197.252 150.11 197.245 150.034 197.235L149.871 197.212C149.056 197.087 148.495 196.316 148.618 195.487C148.741 194.659 149.5 194.09 150.316 194.214L150.461 194.238C151.277 194.366 151.847 195.141 151.721 195.966C151.609 196.717 150.982 197.255 150.259 197.255V197.252ZM112.555 197.07C111.822 197.07 111.185 196.525 111.079 195.767C110.963 194.938 111.534 194.171 112.349 194.056L112.515 194.033C113.331 193.915 114.086 194.494 114.199 195.322C114.312 196.151 113.745 196.919 112.929 197.033L112.764 197.057C112.694 197.067 112.624 197.07 112.555 197.07ZM142.783 196.319C142.736 196.319 142.69 196.319 142.643 196.312L142.481 196.296C141.659 196.222 141.055 195.484 141.128 194.649C141.201 193.814 141.927 193.197 142.75 193.275L142.919 193.292C143.738 193.369 144.341 194.11 144.265 194.942C144.192 195.726 143.542 196.316 142.779 196.316L142.783 196.319ZM120.041 196.215C119.275 196.215 118.622 195.619 118.556 194.827C118.486 193.992 119.096 193.261 119.915 193.191L120.091 193.177C120.91 193.113 121.629 193.736 121.696 194.568C121.759 195.403 121.145 196.131 120.326 196.198L120.167 196.211C120.124 196.215 120.081 196.218 120.041 196.218V196.215ZM135.266 195.831C135.25 195.831 135.23 195.831 135.213 195.831L135.051 195.824C134.229 195.797 133.582 195.097 133.608 194.262C133.635 193.426 134.328 192.773 135.147 192.797L135.319 192.803C136.142 192.834 136.788 193.534 136.758 194.369C136.728 195.188 136.069 195.831 135.27 195.831H135.266ZM127.568 195.797C126.762 195.797 126.099 195.144 126.076 194.322C126.056 193.487 126.706 192.79 127.528 192.766H127.703C128.529 192.753 129.209 193.41 129.225 194.245C129.242 195.08 128.589 195.774 127.763 195.79H127.604C127.604 195.79 127.577 195.794 127.564 195.794L127.568 195.797Z",
    fill: "#5B8AEB"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M245.76 264.918C245.243 264.918 244.743 264.642 244.471 264.147L244.454 264.116L244.434 264.079C244.03 263.349 244.288 262.426 245.005 262.015C245.724 261.604 246.632 261.863 247.037 262.594L247.067 262.648C247.465 263.379 247.213 264.315 246.49 264.719C246.258 264.851 246.006 264.911 245.757 264.911L245.76 264.918Z",
    fill: "#5B8AEB"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M243.788 298.326C270.086 298.326 291.425 277.074 291.449 250.859C291.472 224.643 270.172 203.392 243.873 203.392C217.574 203.392 196.236 224.643 196.212 250.859C196.188 277.074 217.489 298.326 243.788 298.326Z",
    fill: "#50B4EC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_236_26657",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 196,
    y: 203,
    width: 96,
    height: 96
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M243.788 298.326C270.086 298.326 291.425 277.074 291.449 250.859C291.472 224.643 270.172 203.392 243.873 203.392C217.574 203.392 196.236 224.643 196.212 250.859C196.188 277.074 217.489 298.326 243.788 298.326Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_236_26657)"
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M233.173 253.395C233.561 255.404 233.949 258.303 233.791 261.789C233.737 262.96 233.618 265.562 233.031 267.527C231.165 273.757 223.607 276.727 221.278 277.551C228.913 282.289 236.548 287.024 244.183 291.763C251.781 286.964 259.379 282.168 266.973 277.368C264.364 276.46 256.982 273.534 255.173 267.456C254.633 265.64 254.522 263.321 254.448 261.728C254.275 258.08 254.63 255.063 254.984 253.007C247.714 253.136 240.443 253.264 233.173 253.395Z",
    fill: "url(#paint54_linear_236_26657)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M283.756 287.743C283.435 287.078 282.892 285.951 281.835 284.732C280.748 283.477 279.523 282.532 278.045 281.668C275.27 280.048 268.699 276.983 259.757 273.473C258.397 275.454 255.994 278.431 252.18 281.037C248.761 283.372 245.503 284.52 243.289 285.114C241.169 284.499 238.071 283.332 234.831 281.037C231.347 278.573 229.123 275.819 227.83 273.942C224.931 275.404 222.544 276.453 220.972 277.125C215.922 279.282 211.98 280.564 208.409 283.706C208.118 283.959 207.815 284.236 207.416 284.641C204.328 287.8 203.268 291.314 202.428 294.223C202.006 295.691 201.509 297.78 201.253 300.365C207.993 304.179 223.247 311.618 243.995 311.611C264.753 311.604 280.006 304.145 286.74 300.325C286.699 299.917 286.632 299.279 286.53 298.499C286.048 294.78 285.518 291.378 283.756 287.743Z",
    fill: "#E56631"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M249.544 220.267C243.775 218.053 238.682 219.838 237.598 220.246C236.414 220.692 233.129 221.971 230.679 225.11C226.284 230.736 227.749 238.266 229.423 246.875C230.622 253.045 232.292 256.228 233.359 257.996C236.387 263.011 239.917 265.225 241.841 265.532C243.144 265.742 244.555 265.694 244.555 265.694C244.555 265.694 245.875 265.651 247.083 265.387C248.345 265.111 251.309 263.808 254.279 259.181C255.683 256.997 257.432 253.528 258.502 246.875C258.819 244.887 260.807 230.729 256.416 225.197C253.857 221.971 250.556 220.661 249.547 220.273L249.544 220.267Z",
    fill: "url(#paint55_linear_236_26657)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M225.748 244.412C225.164 247.619 228.468 252.709 230.072 251.848C230.959 251.369 231.25 249.097 231.246 247.743C231.239 245.617 230.504 242.691 228.917 241.992C227.55 241.391 226.065 242.667 225.748 244.412Z",
    fill: "url(#paint56_linear_236_26657)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M226.761 245.28C226.491 247.009 227.642 249.435 228.658 249.186C229.309 249.027 229.923 247.761 229.798 246.232C229.687 244.855 229.022 243.812 228.31 243.653C227.601 243.498 226.926 244.237 226.761 245.28Z",
    fill: "url(#paint57_radial_236_26657)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M228.684 246.284C228.438 247.121 228.789 248.583 229.268 248.65C229.575 248.691 229.947 248.161 230.001 247.351C230.048 246.625 229.822 245.96 229.508 245.744C229.197 245.528 228.836 245.781 228.684 246.284Z",
    fill: "url(#paint58_linear_236_26657)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M262.074 244.239C262.688 247.439 259.431 252.563 257.821 251.716C256.926 251.247 256.616 248.978 256.606 247.622C256.592 245.495 257.298 242.562 258.881 241.85C260.241 241.239 261.74 242.498 262.074 244.239Z",
    fill: "url(#paint59_linear_236_26657)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M261.067 245.117C261.354 246.846 260.224 249.279 259.208 249.043C258.556 248.891 257.928 247.632 258.04 246.1C258.138 244.722 258.792 243.673 259.505 243.507C260.213 243.345 260.895 244.078 261.067 245.121V245.117Z",
    fill: "url(#paint60_radial_236_26657)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M259.153 246.14C259.41 246.974 259.072 248.442 258.593 248.513C258.286 248.557 257.908 248.03 257.847 247.22C257.793 246.495 258.012 245.83 258.326 245.61C258.637 245.391 259.001 245.641 259.153 246.144V246.14Z",
    fill: "url(#paint61_linear_236_26657)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M240.819 239.002L233.988 239.034L234.018 245.461L240.849 245.429L240.819 239.002Z",
    fill: "url(#paint62_radial_236_26657)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M254.585 238.907L247.754 238.94L247.785 245.367L254.617 245.334L254.585 238.907Z",
    fill: "url(#paint63_radial_236_26657)"
  }), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M238.287 243.059C238.29 244.055 237.794 244.865 237.173 244.868C236.552 244.868 236.049 244.068 236.042 243.072C236.039 242.077 236.535 241.267 237.156 241.263C237.777 241.263 238.28 242.063 238.287 243.059Z",
    fill: "url(#paint64_linear_236_26657)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M252.676 242.991C252.68 243.987 252.183 244.797 251.562 244.797C250.941 244.797 250.438 243.997 250.432 243.001C250.428 242.005 250.924 241.195 251.546 241.192C252.163 241.192 252.669 241.995 252.676 242.988V242.991Z",
    fill: "url(#paint65_linear_236_26657)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M232.38 239.296C232.137 238.57 234 236.852 236.009 236.508C238.338 236.11 240.791 237.409 240.967 238.25C241.011 238.651 240.727 238.759 240.633 238.797C240.471 238.857 240.312 238.81 240.174 238.753C240.025 238.689 239.894 238.601 239.809 238.547C239.671 238.459 239.482 238.351 239.249 238.24C239.06 238.149 238.682 237.973 238.199 237.868C237.49 237.71 236.906 237.777 236.576 237.818C236.434 237.835 235.87 237.909 235.185 238.182C234.858 238.311 234.449 238.473 233.99 238.803C233.659 239.04 233.035 239.559 232.758 239.546C232.758 239.546 232.471 239.543 232.383 239.299L232.38 239.296Z",
    fill: "url(#paint66_linear_236_26657)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M256.058 239.182C256.294 238.452 254.414 236.751 252.402 236.431C250.07 236.056 247.63 237.376 247.461 238.22C247.42 238.621 247.707 238.726 247.802 238.763C247.964 238.824 248.122 238.773 248.261 238.716C248.409 238.652 248.541 238.56 248.622 238.506C248.76 238.419 248.949 238.307 249.179 238.196C249.368 238.105 249.743 237.926 250.225 237.815C250.934 237.649 251.518 237.71 251.849 237.75C251.991 237.767 252.554 237.835 253.243 238.101C253.57 238.226 253.982 238.385 254.444 238.709C254.775 238.942 255.406 239.455 255.687 239.438C255.687 239.438 255.973 239.431 256.058 239.188V239.182Z",
    fill: "url(#paint67_linear_236_26657)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M246.219 239.275C246.074 239.572 245.881 240.034 245.787 240.618C245.712 241.074 245.716 241.475 245.763 241.982C245.851 242.974 245.996 243.267 246.168 244.26C246.33 245.191 246.539 246.879 246.722 247.908C246.762 248.131 246.803 248.347 246.948 248.58C247.093 248.813 247.221 248.877 247.4 249.16C247.417 249.187 247.586 249.461 247.626 249.66C247.798 250.453 246.317 251.621 245.017 251.928C244.825 251.972 244.706 251.982 244.646 251.985C243.839 252.036 243.225 251.563 242.82 251.253C242.212 250.787 241.837 250.247 241.611 249.839C241.78 249.454 242.026 248.843 242.236 248.07C242.617 246.676 242.411 246.508 242.796 244.3C242.907 243.666 243.063 242.896 243.073 241.857C243.073 241.499 243.063 241.107 242.941 240.638C242.799 240.081 242.57 239.66 242.394 239.386C243.67 239.346 244.946 239.309 246.222 239.268L246.219 239.275Z",
    fill: "url(#paint68_linear_236_26657)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M240.292 257.383C241.524 257.528 242.928 257.629 244.474 257.622C246.067 257.616 247.512 257.497 248.778 257.332C248.47 257.784 247.694 258.794 246.283 259.35C245.858 259.519 244.136 260.201 242.351 259.364C241.105 258.78 240.501 257.774 240.295 257.379L240.292 257.383Z",
    fill: "#E25F32"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M239.55 254.148C240.937 254.405 242.645 254.611 244.599 254.608C246.601 254.608 248.342 254.385 249.75 254.111C249.432 254.638 248.528 255.978 246.766 256.71C246.297 256.906 244.207 257.774 242.051 256.727C240.471 255.961 239.766 254.611 239.546 254.148H239.55Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M250.108 253.593C250.034 253.583 249.973 253.579 249.946 253.579C249.453 253.573 247.992 253.654 247.992 253.654C246.848 253.718 246.78 253.336 245.977 253.488C245.379 253.6 244.937 253.904 244.654 254.137C244.377 253.914 243.935 253.623 243.341 253.512C242.541 253.367 242.476 253.738 241.326 253.684C241.326 253.684 239.891 253.617 239.371 253.63C239.344 253.63 239.287 253.63 239.209 253.644C239.047 253.671 238.916 253.725 238.818 253.779C238.926 253.86 239.098 253.985 239.317 254.117C239.621 254.299 240.529 254.809 242.909 255.086C243.337 255.137 243.938 255.194 244.664 255.218C245.389 255.187 245.987 255.123 246.419 255.069C248.792 254.768 249.7 254.252 250 254.066C250.223 253.931 250.392 253.802 250.496 253.721C250.398 253.671 250.267 253.617 250.105 253.593H250.108Z",
    fill: "#E05F3A"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M235.938 227.465C236.043 228.599 236.512 232.082 239.337 234.799C240.248 235.676 242.402 237.745 245.443 237.6C247.617 237.499 250.479 236.254 251.218 234.59C251.292 234.421 251.454 234.006 251.728 233.979C252.244 233.928 252.585 235.322 253.287 236.331C253.878 237.182 254.982 238.13 257.23 238.62C257.226 240.088 258.029 241.38 259.234 241.849C261.04 242.551 262.694 240.992 262.799 240.891C263.734 239.98 264.321 238.333 264.321 237.334C264.321 237.155 264.301 236.895 264.456 236.625C264.632 236.314 264.986 236.078 265.637 235.643C266.252 235.238 266.701 235.268 267.43 234.431C267.629 234.202 268.874 232.733 268.743 230.719C268.665 229.517 268.088 227.998 267.295 227.884C266.967 227.836 266.849 228.062 266.306 228.069C265.651 228.076 265.151 227.759 264.851 227.56C263.984 226.989 263.525 226.183 263.325 225.764C262.171 223.327 263.855 221.788 262.843 219.466C262.12 217.816 260.601 217.08 260.271 216.918C258.175 215.902 256.146 216.601 255.704 216.766C255.515 216.149 255.208 215.295 254.712 214.34C254.246 213.449 253.125 211.305 251.147 209.962C248.585 208.221 244.829 207.984 241.76 209.594C238.341 211.39 237.227 214.718 237.008 215.426C236.738 214.937 236.114 213.978 234.952 213.411C232.866 212.392 230.743 213.469 230.095 213.796C229.501 214.097 227.783 215.082 226.933 217.232C226.258 218.943 226.497 220.462 226.625 221.056C226.308 220.904 225.144 220.388 224.081 220.901C222.747 221.545 222.352 223.442 222.616 224.725C222.882 226.017 223.831 226.743 223.551 227.128C223.308 227.465 222.578 226.922 221.92 227.222C220.786 227.738 220.516 230.459 221.235 232.646C221.569 233.658 222.275 234.61 223.713 236.493C225.177 238.41 225.576 238.717 225.981 239.261C226.156 239.497 226.268 239.689 226.355 239.838C226.602 240.246 227.014 240.935 227.571 241.93C227.76 241.89 228.276 241.809 228.84 242.059C229.599 242.393 229.883 243.075 229.94 243.22C230.028 242.18 230.163 240.601 230.278 239.254C230.548 236.112 230.615 235.342 230.608 234.195C230.602 233.206 230.537 231.731 230.237 229.919C231.101 229.77 232.225 229.49 233.454 228.933C234.487 228.464 235.314 227.927 235.938 227.458V227.465Z",
    fill: "url(#paint69_linear_236_26657)"
  }))), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M243.826 298.766C231.027 298.766 218.994 293.781 209.941 284.732C200.892 275.68 195.906 263.648 195.906 250.85C195.906 238.052 200.892 226.02 209.941 216.968C218.994 207.92 231.027 202.935 243.826 202.935C256.625 202.935 268.658 207.92 277.711 216.968C286.763 226.017 291.745 238.052 291.745 250.85C291.745 263.648 286.76 275.684 277.711 284.732C268.662 293.781 256.625 298.766 243.826 298.766ZM243.826 203.688C231.226 203.688 219.382 208.595 210.474 217.502C201.567 226.408 196.659 238.251 196.659 250.85C196.659 263.449 201.567 275.292 210.474 284.199C219.382 293.106 231.226 298.013 243.826 298.013C256.426 298.013 268.27 293.106 277.177 284.199C286.085 275.292 290.993 263.449 290.993 250.85C290.993 238.251 286.085 226.408 277.177 217.502C268.27 208.595 256.426 203.688 243.826 203.688Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0966 255.972C91.5582 255.972 117.917 229.703 117.972 197.299C118.026 164.894 91.7548 138.625 59.2932 138.625C26.8317 138.625 0.47234 164.894 0.418041 197.299C0.363743 229.703 26.635 255.972 59.0966 255.972Z",
    fill: "#F98AA0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_236_26657",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 138,
    width: 118,
    height: 118
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0966 255.972C91.5582 255.972 117.917 229.703 117.972 197.299C118.026 164.894 91.7548 138.625 59.2932 138.625C26.8317 138.625 0.47234 164.894 0.418041 197.299C0.363743 229.703 26.635 255.972 59.0966 255.972Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_236_26657)"
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5309 150.087C63.2407 149.243 62.8538 148.472 62.3868 147.792C60.4923 144.247 55.389 143.63 52.9141 147.188C52.4505 147.962 51.6766 148.579 51.5232 149.51C46.8836 147.655 40.6963 148.736 38.685 153.839C38.2213 154.923 38.3748 156.003 38.3748 157.087C37.8945 156.87 34.9826 155.6 32.5711 156.977C30.4597 158.184 29.7759 160.829 29.3056 162.654C29.0922 163.484 28.9921 164.198 28.9421 164.715C27.9548 165.428 26.0436 167.019 24.8661 169.744C22.9449 174.183 24.4092 178.282 24.7661 179.206C24.716 179.653 24.5826 180.36 24.149 181.06C22.9849 182.935 21.1337 182.448 18.9957 184.005C16.394 185.896 15.5301 189.242 15.8137 190.866C15.9838 191.843 16.4341 192.72 16.4341 192.72C16.7343 193.307 17.0745 193.748 17.3413 194.054C14.5562 194.054 10.3802 195.445 11.0006 199.004C11.154 199.621 11.4642 200.088 11.9278 200.551C12.8551 201.478 14.0926 202.252 14.713 203.49C13.3221 203.8 11.9278 204.574 11.2708 206.004C10.7304 207.242 10.7671 208.749 11.4642 210.14C11.9278 210.757 12.238 211.531 12.8551 211.994C14.0926 213.078 15.9471 212.768 17.1845 214.005C17.6482 214.469 17.9584 215.089 17.6482 215.863C17.2613 216.92 17.1412 217.911 17.2312 218.838C17.6882 223.471 23.4486 226.456 27.7013 227.616C29.0922 227.926 30.1762 228.233 31.5671 228.543C35.7431 229.317 39.6089 228.233 43.6315 227.77C44.0951 227.77 44.7155 227.923 45.1791 228.233C47.5006 230.244 48.8915 233.336 52.3371 233.506C53.2009 233.823 54.4284 234.103 55.6525 233.66C56.373 233.4 56.6098 233.063 57.3336 232.749C58.6845 232.162 59.4416 232.646 60.9326 232.576C62.7004 232.492 64.8451 231.185 69.1345 228.567C69.2946 228.47 69.3179 228.453 69.3946 228.41C71.1258 227.413 73.3338 227.096 75.1083 227.503C77.5399 228.06 77.2263 229.531 79.5078 230.041C81.926 230.581 84.0841 229.334 84.6744 228.994C86.4656 227.957 87.4062 226.512 87.8031 225.812C88.6003 226.159 90.5782 226.873 92.6829 226.139C94.9677 225.342 96.1585 223.277 96.6888 222.36C97.7261 220.562 97.3159 219.959 98.3899 218.671C99.6173 217.194 100.508 217.561 101.742 216.31C103.293 214.732 103.813 212.164 103.496 210.143C103.066 207.405 101.262 206.788 101.672 204.94C101.999 203.46 103.223 203.586 104.13 201.592C105.064 199.531 104.627 197.493 104.48 196.853C103.953 194.548 102.559 193.164 102.016 192.644C101.038 191.713 100.111 191.213 99.4973 190.833C98.5967 190.272 97.6461 189.752 96.6921 189.262C96.4053 189.115 95.925 188.428 95.7649 187.561C95.5147 186.203 96.502 185.703 96.7655 184.236C97.2225 181.681 94.9277 179.316 94.4607 178.859C93.5134 177.932 92.5228 177.448 91.8991 177.202C91.849 176.891 91.7957 176.585 91.7456 176.274C92.6729 174.884 93.1365 173.336 93.1632 171.702C93.1632 170.881 93.0265 170.071 92.6996 169.321C92.3727 168.57 91.8624 167.887 91.1252 167.306C90.1213 166.532 88.9972 165.992 87.8198 165.605C86.639 165.218 85.4016 164.988 84.1641 164.831C85.7118 162.203 85.555 158.491 82.9266 156.48C81.6892 155.706 80.2983 155.706 78.9041 155.243C78.287 155.089 77.6666 155.706 77.203 155.243C76.2757 154.469 75.9655 153.232 75.1517 152.114C74.4145 151.144 73.5606 150.27 72.6267 149.59C70.7555 148.226 68.5608 147.625 66.1025 148.666C64.7417 149.189 63.7644 149.927 63.5376 150.103L63.5309 150.087Z",
    fill: "url(#paint70_linear_236_26657)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8428 196.179C51.103 198.473 51.3631 201.788 51.2564 205.781C51.1597 209.386 50.9896 211.077 50.7494 212.341C50.7127 212.538 50.1224 215.576 49.1884 217.697C46.7635 223.197 40.5295 225.872 38.3582 226.702C39.5523 228.323 41.6703 230.774 44.9957 232.789C50.4159 236.071 55.6459 236.131 57.7506 236.127C64.1513 236.117 68.6976 233.743 69.6849 233.206C73.9443 230.895 76.5093 227.833 77.7801 226.069C75.642 225.298 69.268 222.727 66.9798 217.334C66.4261 216.03 65.8891 214.032 65.5622 212.264C65.2187 210.413 65.162 208.742 65.0786 205.714C64.9619 201.545 65.202 198.093 65.4355 195.742C60.5724 195.888 55.7059 196.039 50.8395 196.185L50.8428 196.179Z",
    fill: "url(#paint71_linear_236_26657)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M97.0819 241.127C96.2681 238.545 95.4175 235.894 93.2995 233.566C90.7779 230.794 87.8994 230.117 84.6707 228.987C80.9683 227.693 75.885 225.485 70.0379 221.486C68.6537 222.506 64.2743 225.458 57.9602 225.418C51.973 225.378 47.8037 222.67 46.3761 221.649C40.4857 225.658 35.4258 228.026 31.7468 229.48C28.0677 230.934 24.5555 231.952 22.0272 235.427C20.7797 237.141 20.126 238.966 19.3088 241.257C18.0747 244.709 17.5043 247.704 17.2141 249.792C23.2213 253.417 37.7439 261.088 57.7734 261.104C77.883 261.121 92.4657 253.417 98.4728 249.792C98.4562 247.767 98.216 244.722 97.0819 241.123V241.127Z",
    fill: "#C7BDFB"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6685 175.414C38.0575 182.678 40.2188 188.845 42.1434 194.315C43.2308 197.406 43.9179 199.361 45.5756 201.742C45.5756 201.742 48.1072 205.378 56.1691 210.09C56.576 210.327 57.3365 210.754 58.3371 210.741C59.4245 210.727 60.235 210.204 60.6319 209.937C65.8586 206.465 68.4736 204.727 70.9318 201.132C72.4395 198.931 73.2133 197.11 74.0338 195.145C75.9017 190.683 78.8569 183.575 77.2259 175.177C76.7522 172.739 76.2186 169.981 74.0705 167.25C69.8311 161.86 62.8567 161.08 61.5558 160.936C61.1923 160.896 59.778 160.749 57.8535 160.87C55.9889 160.986 48.1473 161.48 43.3075 167.183C40.8526 170.078 40.1788 173.116 39.6685 175.411V175.414Z",
    fill: "url(#paint72_linear_236_26657)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2061 159.138C61.6297 159.802 62.4869 161.182 62.1667 162.847C61.8699 164.388 60.5957 166.012 59.0648 166.232C57.1669 166.505 56.3097 164.444 54.2383 164.708C52.8875 164.881 52.0002 165.975 51.7601 166.272C49.9623 168.487 51.5399 170.895 49.7021 173.052C49.2585 173.573 48.7748 173.849 47.8109 174.4C44.7656 176.137 43.2146 175.287 42.4208 176.451C41.5235 177.765 43.3047 179.126 42.811 182.594C42.6709 183.578 42.4741 184.962 41.4501 185.676C40.2927 186.48 39.1053 185.716 37.3242 185.676C33.1415 185.586 31.7372 189.628 29.3157 189.075C27.0109 188.548 25.3131 184.209 25.9169 180.58C26.4372 177.468 28.285 177.075 32.2276 172.085C36.0467 167.252 35.9233 165.578 40.723 159.708C42.8811 157.067 44.1218 155.883 45.8196 155.096C50.9929 152.708 58.4777 154.882 61.2028 159.141L61.2061 159.138Z",
    fill: "#BD4516"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2725 158.504C60.6721 160.601 61.1758 162.376 61.4359 163.103C61.7528 163.99 62.0397 164.8 62.7801 165.411C64.7214 167.002 67.0562 164.974 68.6272 166.225C70.365 167.609 69.0208 171.291 70.872 173.819C71.4924 174.666 72.1428 175.18 72.1428 175.18C73.1668 175.99 73.7205 175.89 74.2742 176.45C75.0213 177.211 74.4943 178.095 74.9179 179.635C75.4216 181.456 75.9853 183.494 77.6997 184.441C78.9638 185.138 80.5682 185.092 81.7489 184.568C83.1932 183.928 83.0998 182.974 84.7075 181.663C86.8222 179.939 88.2498 180.729 89.077 179.479C90.8781 176.754 88.063 172.231 87.1357 170.74C84.971 167.265 82.0091 165.317 78.8838 163.216C74.6744 160.388 73.3102 160.538 71.499 158.07C70.3917 156.559 69.9547 155.212 68.307 154.498C67.0062 153.934 65.2817 153.911 63.8375 154.722C62.0697 155.715 61.5593 157.496 61.2725 158.5V158.504Z",
    fill: "#BD4516"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3298 186.797C35.7361 190.463 39.6253 196.19 41.4364 195.172C42.4404 194.605 42.7206 192.01 42.6872 190.466C42.6339 188.041 41.7266 184.722 39.8954 183.965C38.3211 183.315 36.6534 184.802 36.3298 186.797Z",
    fill: "url(#paint73_linear_236_26657)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5076 187.76C37.2374 189.738 38.6083 192.477 39.7624 192.17C40.5029 191.973 41.1766 190.515 40.9999 188.774C40.8398 187.21 40.0593 186.032 39.2421 185.869C38.4282 185.706 37.6744 186.566 37.511 187.76H37.5076Z",
    fill: "url(#paint74_radial_236_26657)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7254 188.861C39.4619 189.819 39.8955 191.48 40.4459 191.543C40.7994 191.583 41.2097 190.969 41.2531 190.045C41.2897 189.215 41.0162 188.464 40.6527 188.224C40.2924 187.988 39.8855 188.281 39.7254 188.861Z",
    fill: "url(#paint75_linear_236_26657)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4684 187.027C80.7952 190.726 76.5025 196.166 74.7714 195.022C73.8108 194.388 73.7174 191.777 73.8641 190.239C74.0943 187.824 75.2384 184.575 77.1196 183.952C78.7373 183.411 80.2916 185.016 80.4717 187.027H80.4684Z",
    fill: "url(#paint76_linear_236_26657)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2244 187.902C79.3512 189.893 77.7835 192.529 76.6561 192.142C75.9323 191.895 75.3653 190.394 75.6688 188.669C75.9423 187.118 76.8062 186.001 77.6334 185.894C78.4573 185.791 79.1477 186.698 79.2244 187.902Z",
    fill: "url(#paint77_radial_236_26657)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9326 188.847C77.1261 189.821 76.5724 191.449 76.0187 191.472C75.6652 191.489 75.2983 190.845 75.3216 189.921C75.345 189.091 75.6718 188.36 76.0521 188.147C76.429 187.934 76.8159 188.257 76.9326 188.847Z",
    fill: "url(#paint78_linear_236_26657)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3811 177.325C53.1943 177.432 52.9908 177.402 52.8041 177.349C52.6073 177.292 52.4272 177.198 52.3137 177.145C52.1236 177.055 51.8701 176.948 51.5599 176.845C51.3064 176.761 50.8061 176.601 50.1857 176.545C49.2751 176.465 48.568 176.655 48.1678 176.768C47.9943 176.818 47.3139 177.012 46.52 177.485C45.7962 177.916 45.2792 178.396 45.1625 178.503C44.382 179.233 44.0618 179.843 43.6449 179.753C43.6282 179.75 43.4581 179.707 43.3814 179.58C43.0845 179.086 44.9824 176.561 47.7708 175.674C47.9143 175.627 49.6921 175.087 51.7034 175.607C52.1903 175.734 53.5712 176.094 53.6479 176.785C53.6613 176.915 53.6279 177.025 53.5912 177.105C53.5545 177.168 53.4912 177.258 53.3811 177.322V177.325Z",
    fill: "url(#paint79_linear_236_26657)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6344 177.325C63.8211 177.432 64.0246 177.402 64.2114 177.349C64.4082 177.292 64.5883 177.198 64.7017 177.145C64.8918 177.055 65.1487 176.948 65.4555 176.845C65.709 176.761 66.2093 176.601 66.8297 176.545C67.7403 176.465 68.4474 176.655 68.8477 176.768C69.0211 176.818 69.7016 177.012 70.4921 177.485C71.2159 177.916 71.7329 178.396 71.8463 178.503C72.6234 179.233 72.947 179.843 73.3606 179.753C73.3773 179.75 73.5474 179.707 73.6241 179.58C73.9243 179.086 72.0297 176.561 69.2413 175.674C69.0979 175.627 67.32 175.087 65.3121 175.607C64.8218 175.734 63.4409 176.094 63.3675 176.785C63.3542 176.915 63.3875 177.025 63.4209 177.105C63.4576 177.168 63.5209 177.258 63.631 177.322L63.6344 177.325Z",
    fill: "url(#paint80_linear_236_26657)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M64.8755 191.73C64.8722 195.322 67.7874 198.23 71.3863 198.23C74.9853 198.23 77.9038 195.318 77.9072 191.73C77.9105 188.138 74.9953 185.226 71.3963 185.226C67.7974 185.226 64.8788 188.138 64.8755 191.73Z",
    fill: "url(#paint81_radial_236_26657)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M39.0549 191.73C39.0549 195.322 41.9668 198.23 45.5658 198.23C49.1647 198.23 52.0833 195.318 52.0866 191.73C52.09 188.138 49.1747 185.226 45.5758 185.226C41.9768 185.226 39.0583 188.138 39.0549 191.73Z",
    fill: "url(#paint82_radial_236_26657)"
  }), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3636 178.565C62.3429 179.492 60.7819 181.223 60.1115 183.774C59.7379 185.192 59.778 186.769 59.7813 187.196C59.788 187.953 59.798 188.574 59.9748 189.394C60.1349 190.125 60.385 191.285 61.2156 192.403C61.4524 192.723 61.6658 192.836 61.7292 193.156C61.8726 193.89 61.1388 194.604 60.7953 194.937C60.3917 195.328 59.858 195.851 59.0208 195.948C58.0769 196.055 57.3564 195.558 56.8294 195.194C55.9689 194.601 55.4952 193.843 55.2484 193.353C55.5786 193.066 56.0289 192.616 56.4292 191.979C57.3864 190.448 57.4031 188.884 57.3998 187.373C57.3998 186.523 57.3931 185.282 56.9361 183.768C56.159 181.196 54.5813 179.509 53.634 178.652C56.8794 178.622 60.1215 178.595 63.3636 178.565Z",
    fill: "url(#paint83_linear_236_26657)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2451 199.493C54.4519 199.746 56.0096 201.577 58.7413 201.684C61.7499 201.801 63.5477 199.723 63.7145 199.523C63.6345 199.913 63.4944 200.463 63.2309 201.09C62.914 201.844 62.6171 202.551 61.9334 203.188C61.6599 203.442 60.7459 204.269 59.2817 204.399C57.5939 204.549 56.3965 203.669 56.1096 203.442C55.169 202.701 54.8355 201.774 54.592 201.104C54.3585 200.46 54.2751 199.893 54.2451 199.496V199.493Z",
    fill: "#E66E64"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6655 199.76C54.7422 199.79 54.8556 199.834 54.9924 199.88C55.3126 199.987 55.5828 200.04 56.0731 200.12C56.5 200.191 56.7168 200.227 57.0671 200.271C57.7308 200.351 58.2945 200.421 59.0483 200.414C59.6087 200.407 60.069 200.361 60.2825 200.341C60.5593 200.311 60.7661 200.281 61.093 200.234C61.6033 200.161 61.8968 200.12 62.2704 200.04C62.5239 199.987 62.8775 199.904 63.2977 199.777C63.0709 200.204 62.3238 201.471 60.7561 202.138C60.3825 202.299 58.598 203.059 56.7769 202.135C55.3726 201.418 54.8156 200.137 54.6689 199.764L54.6655 199.76Z",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8072 199.067C63.5603 199.097 63.3535 199.087 63.1668 199.061C62.6965 198.994 61.6691 198.677 61.6691 198.677C61.0654 198.49 60.7652 198.4 60.5417 198.397C60.1848 198.39 59.6612 198.49 59.0174 199.017C58.4671 198.53 57.9834 198.413 57.6632 198.397C57.3464 198.38 57.0195 198.48 56.3691 198.677C56.3691 198.677 55.3251 198.997 54.8714 199.061C54.6847 199.087 54.4779 199.097 54.231 199.067C53.9108 199.027 53.6573 198.93 53.4939 198.85C53.6507 199.034 53.9008 199.291 54.2677 199.531C54.9248 199.958 55.5652 200.055 56.8194 200.235C57.4564 200.325 58.0768 200.411 58.9374 200.415C59.7913 200.415 60.3916 200.331 61.2122 200.218C63.0534 199.961 63.5537 199.674 63.7705 199.531C64.1407 199.291 64.3942 199.031 64.5443 198.85C64.3809 198.927 64.1274 199.024 63.8072 199.067Z",
    fill: "#E8786F"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M52.6277 179.449H44.9294V186.881H52.6277V179.449Z",
    fill: "url(#paint84_radial_236_26657)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M72.0232 179.449H64.325V186.881H72.0232V179.449Z",
    fill: "url(#paint85_radial_236_26657)"
  }), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0684 184.775C66.0684 185.999 66.7288 186.99 67.546 186.99C68.3632 186.99 69.0269 185.999 69.0269 184.775C69.0269 183.551 68.3665 182.561 67.5493 182.561C66.7321 182.561 66.0684 183.555 66.0684 184.775Z",
    fill: "url(#paint86_linear_236_26657)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9473 184.775C47.9473 185.999 48.6077 186.99 49.4249 186.99C50.2421 186.99 50.9058 185.999 50.9058 184.775C50.9058 183.551 50.2454 182.561 49.4282 182.561C48.611 182.561 47.9473 183.555 47.9473 184.775Z",
    fill: "url(#paint87_linear_236_26657)"
  }))), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1948 256.485C43.3847 256.485 28.5185 250.328 17.338 239.148C6.15752 227.969 0.000244141 213.107 0.000244141 197.298C0.000244141 181.49 6.15752 166.625 17.338 155.445C28.5185 144.266 43.3814 138.109 59.1948 138.109C75.0083 138.109 89.8711 144.266 101.052 155.445C112.232 166.625 118.389 181.486 118.389 197.298C118.389 213.111 112.232 227.972 101.052 239.152C89.8711 250.331 75.0049 256.488 59.1948 256.488V256.485ZM59.1948 139.039C43.6315 139.039 29.0021 145.099 17.9984 156.102C6.99472 167.105 0.934176 181.736 0.934176 197.295C0.934176 212.854 6.99472 227.485 17.9984 238.488C29.0021 249.491 43.6349 255.551 59.1948 255.551C74.7548 255.551 89.3875 249.491 100.391 238.488C111.395 227.485 117.455 212.857 117.455 197.295C117.455 181.733 111.395 167.105 100.391 156.102C89.3875 145.099 74.7548 139.039 59.1948 139.039Z",
    fill: "white"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M240.913 112.248C271.829 112.248 296.933 87.23 296.985 56.3687C297.036 25.5073 272.016 0.489258 241.1 0.489258C210.185 0.489258 185.08 25.5073 185.029 56.3687C184.977 87.23 209.997 112.248 240.913 112.248Z",
    fill: "#CACAC8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_236_26657",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 185,
    y: 0,
    width: 112,
    height: 113
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M240.913 112.248C271.829 112.248 296.933 87.23 296.985 56.3687C297.036 25.5073 272.016 0.489258 241.1 0.489258C210.185 0.489258 185.08 25.5073 185.029 56.3687C184.977 87.23 209.997 112.248 240.913 112.248Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_236_26657)"
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M227.922 56.6854C228.386 59.0741 228.847 62.5236 228.656 66.6719C228.593 68.0663 228.453 71.1601 227.751 73.4948C225.527 80.9084 216.541 84.4373 213.771 85.4157C222.853 91.0505 231.938 96.6854 241.02 102.32C250.057 96.6124 259.095 90.9044 268.132 85.1997C265.029 84.1197 256.249 80.6384 254.095 73.409C253.45 71.2491 253.323 68.4888 253.231 66.5957C253.027 62.2568 253.45 58.6675 253.869 56.2217C245.219 56.3741 236.572 56.5298 227.922 56.6823V56.6854Z",
    fill: "url(#paint88_linear_236_26657)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M288.094 97.5421C287.71 96.7512 287.065 95.4108 285.81 93.9592C284.52 92.4663 283.059 91.3419 281.302 90.3159C278.002 88.3878 270.187 84.7414 259.549 80.5708C257.052 83.4009 254.066 86.463 250.534 89.5663C246.912 92.749 243.402 95.3727 240.203 97.5167C237.026 95.4076 233.513 92.7903 229.892 89.5663C226.626 86.6567 223.869 83.7821 221.566 81.1235C218.116 82.861 215.276 84.1093 213.408 84.9097C207.401 87.4762 202.709 89.0009 198.465 92.7395C198.119 93.0444 197.757 93.3684 197.284 93.8512C193.608 97.6088 192.347 101.789 191.35 105.251C190.845 106.995 190.257 109.482 189.955 112.557C197.97 117.093 216.118 125.945 240.797 125.936C265.489 125.926 283.634 117.055 291.646 112.509C291.598 112.023 291.519 111.264 291.398 110.337C290.826 105.912 290.194 101.865 288.094 97.5421Z",
    fill: "#C26044"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M247.871 17.2971C241.044 14.6385 234.99 16.7254 233.7 17.205C232.293 17.7259 228.386 19.2252 225.457 22.932C220.199 29.5801 221.88 38.5184 223.802 48.7368C225.177 56.0583 227.134 59.8445 228.386 61.9473C231.94 67.9125 236.111 70.5552 238.389 70.9332C239.933 71.1873 241.607 71.1397 241.607 71.1397C241.607 71.1397 243.173 71.0952 244.605 70.7903C246.105 70.4695 249.631 68.9416 253.189 63.4719C254.869 60.8895 256.972 56.7857 258.29 48.9019C258.684 46.5483 261.149 29.7675 255.981 23.1829C252.97 19.3427 249.062 17.7672 247.871 17.3035V17.2971Z",
    fill: "url(#paint89_linear_236_26657)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M219.456 45.7964C218.738 49.5921 222.623 55.6495 224.525 54.6394C225.583 54.0772 225.945 51.3868 225.952 49.7795C225.961 47.2575 225.11 43.7826 223.233 42.9472C221.616 42.2293 219.846 43.7349 219.456 45.7996V45.7964Z",
    fill: "url(#paint90_linear_236_26657)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M220.654 46.8315C220.317 48.8805 221.668 51.7649 222.875 51.4758C223.65 51.2915 224.387 49.7953 224.25 47.9783C224.126 46.3455 223.348 45.1034 222.503 44.9128C221.664 44.7222 220.858 45.5958 220.654 46.8347V46.8315Z",
    fill: "url(#paint91_radial_236_26657)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M222.928 48.0321C222.626 49.0232 223.033 50.7608 223.605 50.8402C223.97 50.8911 224.415 50.2621 224.484 49.3027C224.548 48.4419 224.281 47.6541 223.909 47.3936C223.541 47.1363 223.109 47.4317 222.928 48.0289V48.0321Z",
    fill: "url(#paint92_linear_236_26657)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M262.551 45.7964C263.256 49.5921 259.352 55.6495 257.449 54.6394C256.394 54.0772 256.039 51.3868 256.039 49.7795C256.039 47.2575 256.899 43.7826 258.78 42.9472C260.4 42.2293 262.166 43.7349 262.548 45.7996L262.551 45.7964Z",
    fill: "url(#paint93_linear_236_26657)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M261.354 46.8315C261.681 48.8805 260.321 51.7649 259.118 51.4758C258.346 51.2915 257.612 49.7953 257.755 47.9783C257.882 46.3455 258.666 45.1034 259.511 44.9128C260.353 44.7222 261.157 45.5958 261.354 46.8347V46.8315Z",
    fill: "url(#paint94_radial_236_26657)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M259.073 48.0321C259.371 49.0232 258.958 50.7608 258.386 50.8402C258.021 50.8911 257.58 50.2621 257.513 49.3027C257.452 48.4419 257.723 47.6541 258.094 47.3936C258.463 47.1363 258.892 47.4317 259.073 48.0289V48.0321Z",
    fill: "url(#paint95_linear_236_26657)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M237.379 45.851H229.275L229.288 38.2271H237.391L237.379 45.851Z",
    fill: "url(#paint96_radial_236_26657)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M253.672 45.851H245.569L245.581 38.2271H253.685L253.672 45.851Z",
    fill: "url(#paint97_radial_236_26657)"
  }), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M234.361 43.8122C234.361 44.9939 233.761 45.9501 233.027 45.9501C232.293 45.9501 231.699 44.9939 231.699 43.8122C231.699 42.6305 232.3 41.6743 233.034 41.6743C233.767 41.6743 234.361 42.6305 234.361 43.8122Z",
    fill: "url(#paint98_linear_236_26657)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M251.433 43.8122C251.433 44.9939 250.832 45.9501 250.098 45.9501C249.365 45.9501 248.771 44.9939 248.771 43.8122C248.771 42.6305 249.371 41.6743 250.105 41.6743C250.839 41.6743 251.433 42.6305 251.433 43.8122Z",
    fill: "url(#paint99_linear_236_26657)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M227.363 39.764C227.081 38.9 229.304 36.8733 231.687 36.4794C234.453 36.022 237.354 37.5722 237.554 38.5728C237.602 39.0493 237.265 39.1764 237.15 39.2177C236.96 39.2876 236.772 39.2336 236.607 39.1637C236.433 39.0874 236.277 38.9826 236.178 38.9159C236.013 38.8111 235.791 38.6808 235.514 38.5506C235.289 38.4426 234.844 38.2329 234.272 38.1027C233.431 37.9121 232.738 37.9883 232.347 38.0328C232.176 38.0518 231.512 38.1376 230.696 38.4553C230.308 38.6046 229.822 38.7952 229.272 39.1827C228.882 39.4623 228.132 40.0722 227.805 40.0563C227.805 40.0563 227.465 40.0499 227.363 39.764Z",
    fill: "url(#paint100_linear_236_26657)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M255.454 39.764C255.74 38.9 253.523 36.8733 251.14 36.4794C248.377 36.022 245.47 37.5722 245.267 38.5728C245.216 39.0493 245.553 39.1764 245.667 39.2177C245.858 39.2876 246.045 39.2336 246.21 39.1637C246.385 39.0874 246.544 38.9826 246.642 38.9159C246.807 38.8111 247.03 38.6808 247.306 38.5506C247.532 38.4426 247.976 38.2329 248.551 38.1027C249.393 37.9121 250.086 37.9883 250.476 38.0328C250.648 38.0518 251.312 38.1376 252.125 38.4553C252.513 38.6046 252.999 38.7952 253.545 39.1827C253.936 39.4623 254.682 40.0722 255.013 40.0563C255.013 40.0563 255.352 40.0499 255.454 39.764Z",
    fill: "url(#paint101_linear_236_26657)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M243.783 39.8186C243.608 40.1712 243.376 40.7143 243.259 41.4068C243.166 41.9499 243.17 42.4232 243.217 43.0236C243.313 44.202 243.484 44.5482 243.678 45.7266C243.862 46.8352 244.097 48.8363 244.304 50.056C244.348 50.3228 244.396 50.577 244.567 50.8533C244.736 51.1328 244.891 51.2059 245.098 51.5457C245.117 51.5775 245.314 51.9047 245.365 52.1397C245.562 53.0799 243.795 54.4585 242.252 54.8142C242.023 54.8682 241.883 54.8778 241.81 54.8841C240.854 54.9381 240.126 54.3759 239.65 54.0074C238.935 53.4516 238.494 52.8099 238.23 52.324C238.433 51.8666 238.729 51.1455 238.986 50.2307C239.45 48.579 239.205 48.3789 239.679 45.7648C239.815 45.012 240.006 44.1003 240.025 42.8679C240.031 42.4423 240.018 41.9785 239.879 41.4227C239.713 40.762 239.443 40.2569 239.24 39.933C240.752 39.8948 242.267 39.8535 243.78 39.8154L243.783 39.8186Z",
    fill: "url(#paint102_linear_236_26657)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "hard-light"
    },
    opacity: 0.2,
    d: "M244.063 51.5769C244.037 52.0406 243.618 52.3678 243.484 52.4727C243.326 52.5966 243.021 52.8348 242.582 52.8316C242.172 52.8284 241.89 52.6156 241.718 52.4886C241.566 52.3742 241.13 52.047 241.099 51.58C241.061 50.9701 241.725 50.2554 242.582 50.2554C243.44 50.2554 244.097 50.9638 244.063 51.58V51.5769Z",
    fill: "url(#paint103_linear_236_26657)"
  }), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M236.613 61.6907C238.075 61.8718 239.739 61.9956 241.572 61.9988C243.462 61.9988 245.177 61.8686 246.68 61.6812C246.315 62.218 245.384 63.4061 243.704 64.0605C243.195 64.2574 241.15 65.0547 239.04 64.0541C237.566 63.3552 236.861 62.1608 236.616 61.6907H236.613Z",
    fill: "#DE5729"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M235.756 57.8545C237.398 58.1658 239.425 58.4199 241.744 58.4263C244.117 58.4326 246.188 58.1817 247.859 57.8672C247.478 58.493 246.395 60.075 244.298 60.9327C243.739 61.1614 241.255 62.1779 238.704 60.9263C236.833 60.0114 236.007 58.4072 235.753 57.8545H235.756Z",
    fill: "white"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M248.284 57.2576C248.195 57.2449 248.125 57.2417 248.094 57.2417C247.509 57.2322 245.775 57.3179 245.775 57.3179C244.415 57.3878 244.339 56.9336 243.389 57.1114C242.681 57.2417 242.15 57.5975 241.817 57.8738C241.489 57.607 240.965 57.2607 240.263 57.1273C239.313 56.9494 239.237 57.391 237.874 57.3179C237.874 57.3179 236.172 57.2322 235.556 57.2417C235.524 57.2417 235.454 57.2417 235.365 57.2576C235.174 57.2862 235.015 57.3529 234.901 57.4132C235.028 57.5085 235.231 57.6578 235.492 57.8198C235.851 58.039 236.925 58.6489 239.742 58.9888C240.251 59.0492 240.962 59.1223 241.823 59.154C242.684 59.1191 243.395 59.0492 243.904 58.9888C246.721 58.6489 247.801 58.039 248.16 57.8198C248.424 57.6578 248.627 57.5117 248.751 57.4132C248.637 57.3529 248.481 57.2862 248.287 57.2576H248.284Z",
    fill: "#DC5732"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M258.418 42.9902C258.288 43.0728 258.135 43.1872 257.98 43.3333C257.869 43.4381 257.776 43.5429 257.7 43.6414C257.7 43.6954 257.697 43.7748 257.694 43.8733C257.64 45.1946 257.329 49.4128 254.797 54.1043C254.304 55.016 253.558 56.2484 252.468 57.6047C251.661 56.9917 250.34 56.1213 248.542 55.5273C246.668 54.908 245.025 54.8953 241.814 54.8889C238.933 54.8857 237.494 54.8825 235.934 55.1907C234.352 55.5019 232.09 56.1626 229.581 57.7C228.478 56.2706 227.722 54.981 227.217 54.0218C226.251 52.1826 224.326 48.5298 224.32 43.7907C224.32 43.7272 224.32 43.6763 224.32 43.6414C224.253 43.5588 224.171 43.4667 224.069 43.3778C223.904 43.2285 223.739 43.1205 223.599 43.0474C223.494 48.1995 223.929 52.4844 224.415 55.6862C224.905 58.8943 225.165 60.5397 226.001 62.4232C226.001 62.4232 228.494 68.0422 234.568 71.6093C236.274 72.6098 237.573 72.9688 238.132 73.1054C238.793 73.2673 240.064 73.5183 241.671 73.4357C242.078 73.4166 243.65 73.315 245.54 72.613C248.485 71.5172 250.337 69.6495 251.712 68.236C252.951 66.9623 255.4 64.3862 256.684 60.2919C257.16 58.7736 257.29 57.5856 257.449 56.2452C257.84 52.9767 258.259 48.4981 258.418 42.9902ZM250.276 61.0447C249.851 63.7732 245.597 66.2222 241.598 66.1936C237.754 66.165 233.288 63.8431 233.107 61.0733C233.03 59.9171 233.729 58.313 234.978 57.4967C235.381 57.2331 235.832 57.0584 236.734 56.9027C238.701 56.5597 239.768 56.8233 241.731 56.9027C244.841 57.0266 245.54 56.4961 247.618 57.1187C248.733 57.4522 249.323 57.8429 249.724 58.3893C250.521 59.4756 250.311 60.8255 250.276 61.0479V61.0447Z",
    fill: "url(#paint104_linear_236_26657)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M259.174 13.73C257.9 12.6787 256.112 12.2625 255.248 12.0593C253.809 11.7226 252.57 11.6972 251.722 11.7353C250.756 10.9793 249.902 10.5918 249.365 10.3853C246.506 9.28947 242.224 9.38794 241.013 8.61608C240.623 8.36832 240.384 8.11104 240.384 8.11104C239.943 7.6187 239.927 7.15495 238.99 6.46568C236.757 4.81715 234.034 5.09349 233.431 5.15702C230.667 5.43654 228.866 6.95802 228.262 7.51706C227.567 7.69493 223.285 8.86701 220.931 13.2504C218.526 17.7322 220.032 22.0521 220.273 22.7096C219.955 23.9071 219.606 25.6382 219.552 27.7442C219.508 29.5896 219.758 31.073 220.07 33.0582C220.718 37.1684 221.674 40.4814 222.443 42.7715C222.503 42.7779 222.586 42.7842 222.684 42.8001C222.729 42.8065 222.789 42.816 222.859 42.8287C222.967 42.8478 223.075 42.8764 223.183 42.9145C223.615 43.0606 223.987 43.3242 224.311 43.6482C223.85 40.3003 224.276 37.8386 224.784 36.1679C225.175 34.8751 225.572 33.9667 226.258 31.6161C226.807 29.7389 227.163 28.1793 227.382 27.1248C228.704 28.0078 229.828 28.5192 230.308 28.7352C232.624 29.7802 234.565 30.0438 235.959 30.2249C242.141 31.019 246.814 29.0782 251.839 26.9914C253.266 26.3974 254.667 25.7303 256.029 24.571C256.08 24.6059 256.137 24.6377 256.166 24.6917C256.366 25.0442 256.156 25.8225 254.181 27.741C254.323 28.4684 254.568 29.5674 254.981 30.8665C255.642 32.9343 256.353 34.3383 256.598 34.8592C258.148 38.1658 257.815 42.1045 257.703 43.5148C257.7 43.572 257.694 43.6165 257.694 43.6419C257.9 43.4227 258.282 43.0955 258.841 42.9081C259.009 42.851 259.181 42.8224 259.349 42.8033C260.003 40.7323 260.836 37.7783 261.503 34.1572C262.252 30.0915 262.316 28.4334 262.306 27.633C262.271 24.9045 261.75 22.681 261.296 21.1945C261.372 20.664 261.966 16.0424 259.165 13.7332L259.174 13.73ZM221.798 13.6157C223.72 10.0486 226.76 8.53032 227.735 8.0888C226.461 9.08936 224.577 10.8268 223.027 13.495C221.039 16.9127 220.6 20.1399 220.489 21.8901C220.302 20.861 219.797 17.3352 221.801 13.6189L221.798 13.6157ZM259.965 18.3802C259.092 16.9 258.135 15.8836 257.437 15.242C255.731 13.676 253.958 12.8692 253.037 12.4595C252.856 12.3801 252.71 12.3165 252.618 12.2784C253.52 12.3642 255.527 12.685 257.449 14.1779C258.015 14.6162 259.46 15.7724 260.261 17.8561C260.642 18.8535 260.753 19.7429 260.785 20.34C260.512 19.6857 260.238 19.0314 259.968 18.3802H259.965Z",
    fill: "url(#paint105_linear_236_26657)"
  }))), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M241.007 112.742C225.95 112.742 211.792 106.878 201.144 96.2312C190.495 85.584 184.631 71.4301 184.631 56.371C184.631 41.3118 190.495 27.1579 201.144 16.5107C211.792 5.86357 225.947 0 241.007 0C256.068 0 270.223 5.86357 280.871 16.5107C291.519 27.1579 297.383 41.3118 297.383 56.371C297.383 71.4301 291.519 85.584 280.871 96.2312C270.223 106.878 256.068 112.742 241.007 112.742ZM241.007 0.889383C226.185 0.889383 212.252 6.66084 201.772 17.1397C191.293 27.6185 185.521 41.55 185.521 56.371C185.521 71.1919 191.293 85.1234 201.772 95.6022C212.252 106.081 226.188 111.853 241.007 111.853C255.826 111.853 269.762 106.081 280.242 95.6022C290.722 85.1234 296.493 71.1887 296.493 56.371C296.493 41.5532 290.722 27.6185 280.242 17.1397C269.762 6.66084 255.829 0.889383 241.007 0.889383Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_236_26657",
    x1: 570.782,
    y1: 94.9331,
    x2: 570.782,
    y2: 127.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#E68678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#E68779"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#EB9D8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#EDA693"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_236_26657",
    x1: 570.552,
    y1: 66.5468,
    x2: 570.542,
    y2: 107.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E68678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#E78E7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#ECA592"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDA693"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_236_26657",
    x1: 585.896,
    y1: 85.237,
    x2: 585.896,
    y2: 94.5732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E49382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA9B8A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_236_26657",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(624.864 124.801) rotate(41.5899) scale(1.81896 2.39675)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA7066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#C6796D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D88779"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E49080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E89383"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_236_26657",
    x1: 583.724,
    y1: 89.7035,
    x2: 584.995,
    y2: 89.6685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E89787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EA998A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#EE9F92"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_236_26657",
    x1: 555.337,
    y1: 85.2559,
    x2: 555.337,
    y2: 94.4669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E49382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA9B8A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_236_26657",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(483.61 163.662) rotate(134.38) scale(1.81895 2.39674)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA7066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#C6796D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D88779"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E49080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E89383"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_236_26657",
    x1: 564.042,
    y1: 86.285,
    x2: 562.743,
    y2: 86.2412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E89787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#E9998A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#EE9F92"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_236_26657",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(560.001 91.6764) scale(5.28576 5.28575)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA5475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F29CAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#F9D1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FDF2F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_236_26657",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(580.948 27.0862) scale(0.168766)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA5475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#F29CAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#F9D1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#FDF2F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_236_26657",
    x1: 570.471,
    y1: 80.9717,
    x2: 570.471,
    y2: 95.1198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#EC8D7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#EC9D8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#EDA693"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E68678"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_236_26657",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(578.552 84.8498) rotate(180) scale(3.06817 3.06816)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDAFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#E4C0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#F2E2F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FBF7FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_236_26657",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(562.816 27.0879) rotate(180) scale(3.06817 3.06816)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDAFD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#E4C0DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#F2E2F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FBF7FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_236_26657",
    x1: 562.774,
    y1: 87.7706,
    x2: 562.771,
    y2: 84.1627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A9F6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#788F5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#66804E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_236_26657",
    x1: 577.468,
    y1: 87.7683,
    x2: 577.468,
    y2: 84.1635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A9F6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#788F5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#66804E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_236_26657",
    x1: 570.033,
    y1: 91.4409,
    x2: 570.033,
    y2: 93.5471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_236_26657",
    x1: 356.294,
    y1: 136.857,
    x2: 356.294,
    y2: 175.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E25F32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#E86F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#EF7F4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#F38857"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F58C5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_236_26657",
    x1: 356.836,
    y1: 149.477,
    x2: 357.064,
    y2: 102.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58C5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#F28554"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#E6693B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E25F32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_236_26657",
    x1: 369.239,
    y1: 129.498,
    x2: 374.321,
    y2: 131.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB7646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#EB7748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#EC7B4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE8158"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_236_26657",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(346.482 108.97) rotate(40.41) scale(1.96528 2.58955)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA532A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#C65B30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D8693B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E47141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E87444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_236_26657",
    x1: 381.792,
    y1: 135.574,
    x2: 383.237,
    y2: 135.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB7646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#EB7849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ED7E54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#EE8158"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_236_26657",
    x1: 344.156,
    y1: 129.309,
    x2: 339.05,
    y2: 131.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB7646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#EB7748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#EC7B4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE8158"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_236_26657",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(202.029 247.374) rotate(140.14) scale(1.96528 2.58954)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA532A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#C65B30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D8693B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E47141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E87444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_236_26657",
    x1: 360.047,
    y1: 124.255,
    x2: 358.603,
    y2: 123.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB7646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#EB7849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ED7E54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#EE8158"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_236_26657",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(361.303 126.255) rotate(-179.73) scale(3.36533 3.26731)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7B799"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#F0D3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F8EBE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FDF9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_236_26657",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(347.526 126.19) rotate(-179.73) scale(3.36533 3.26731)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7B799"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#F0D3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F8EBE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FDF9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_236_26657",
    x1: 363.368,
    y1: 128.72,
    x2: 363.368,
    y2: 125.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8725D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#C66450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#9E4836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#863626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#7D3020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_236_26657",
    x1: 348.967,
    y1: 128.65,
    x2: 348.967,
    y2: 125.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8725D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#C66450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#9E4836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#863626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#7D3020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_236_26657",
    x1: 359.513,
    y1: 121.713,
    x2: 368.137,
    y2: 121.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B4D3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#984A3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#873B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823627"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_236_26657",
    x1: 353.016,
    y1: 121.681,
    x2: 344.396,
    y2: 121.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B4D3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#984A3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#873B2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#823627"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_236_26657",
    x1: 355.909,
    y1: 123.038,
    x2: 355.847,
    y2: 135.758,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA6D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#F58753"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F38350"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#EE7947"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#E66839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#E25F32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_236_26657",
    x1: 355.212,
    y1: 131.84,
    x2: 355.201,
    y2: 134.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#838383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#969696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_236_26657",
    x1: 356.781,
    y1: 126.421,
    x2: 356.783,
    y2: 93.6567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF6E5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#AD5E4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#954838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#873A2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#823627"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_236_26657",
    x1: 582.739,
    y1: 286.115,
    x2: 582.739,
    y2: 230.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#A55555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#A25353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#914849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#854142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#7E3D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D3C3E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_236_26657",
    x1: 581.884,
    y1: 262.351,
    x2: 581.884,
    y2: 301.326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E67B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#EA835A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#F09167"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#F4996F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F69C72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_236_26657",
    x1: 581.841,
    y1: 274.839,
    x2: 581.841,
    y2: 229.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69C72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67B52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_236_26657",
    x1: 583.663,
    y1: 227.35,
    x2: 568.707,
    y2: 227.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#A55555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#8B4446"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_236_26657",
    x1: 582.138,
    y1: 251.723,
    x2: 582.117,
    y2: 222.448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#A55555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#8B4446"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_236_26657",
    x1: 582.395,
    y1: 226.06,
    x2: 582.397,
    y2: 238.297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B4446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A55555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_236_26657",
    x1: 589.395,
    y1: 238.029,
    x2: 589.395,
    y2: 221.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B4446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A55555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_236_26657",
    x1: 594.512,
    y1: 254.749,
    x2: 599.606,
    y2: 257.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F08C62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F08D64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#F1936B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39972"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_236_26657",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(596.84 255.496) rotate(39.5898) scale(1.96815 2.57017)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF6B44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#CB734B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#DD7F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E9875D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8A60"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_236_26657",
    x1: 605.591,
    y1: 260.287,
    x2: 607.039,
    y2: 259.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F08C62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F08E65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F29770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F39972"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_236_26657",
    x1: 569.247,
    y1: 254.824,
    x2: 564.157,
    y2: 257.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F08C62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F08D64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#F1936B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F39972"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_236_26657",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(491.026 320.784) rotate(140.369) scale(1.96813 2.57015)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF6B44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#CB734B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#DD7F56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E9875D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED8A60"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_236_26657",
    x1: 572.565,
    y1: 254.76,
    x2: 571.114,
    y2: 254.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F08C62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#F08E65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F29770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F39972"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_236_26657",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(588.547 250.502) rotate(180) scale(3.37228 3.27406)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0C0A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#F4D4C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FAEBE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#FDF9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_236_26657",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(574.75 61.1433) rotate(180) scale(3.37228 3.27406)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0C0A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#F4D4C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FAEBE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#FDF9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_236_26657",
    x1: 588.62,
    y1: 253.722,
    x2: 588.623,
    y2: 250.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#784842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#58342F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#4A2B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_236_26657",
    x1: 574.402,
    y1: 253.725,
    x2: 574.405,
    y2: 250.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#784842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#58342F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#4A2B27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_236_26657",
    x1: 593.601,
    y1: 247.137,
    x2: 584.943,
    y2: 247.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B4446"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A55555"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_236_26657",
    x1: 578.419,
    y1: 247.137,
    x2: 569.764,
    y2: 247.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A55555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B4446"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_236_26657",
    x1: 581.206,
    y1: 248.483,
    x2: 581.206,
    y2: 261.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE8760"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#F69C72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F4986E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#EF8E64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#E77D54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#E67B52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_236_26657",
    x1: 580.97,
    y1: 256.741,
    x2: 580.97,
    y2: 259.371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#939393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_236_26657",
    x1: 244.582,
    y1: 253.007,
    x2: 244.582,
    y2: 291.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E25F32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#E86F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#EF7F4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#F38857"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F58C5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_236_26657",
    x1: 243.696,
    y1: 265.69,
    x2: 243.469,
    y2: 219.173,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58C5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#F28554"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#E6693B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E25F32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_236_26657",
    x1: 231.372,
    y1: 245.627,
    x2: 226.295,
    y2: 248.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB7646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#EB7748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#EC7B4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE8158"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_236_26657",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(197.686 273.398) rotate(139.59) scale(1.96241 2.58577)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA532A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#C65B30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D8693B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E47141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E87444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_236_26657",
    x1: 224.034,
    y1: 249.964,
    x2: 222.589,
    y2: 249.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB7646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#EB7849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ED7E54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#EE8158"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_236_26657",
    x1: 256.468,
    y1: 245.495,
    x2: 261.571,
    y2: 247.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB7646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#EB7748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#EC7B4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE8158"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_236_26657",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(284.522 267.988) rotate(39.8599) scale(1.96242 2.58577)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA532A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#C65B30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#D8693B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E47141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E87444"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_236_26657",
    x1: 264.835,
    y1: 250.164,
    x2: 266.276,
    y2: 249.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB7646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#EB7849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ED7E54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#EE8158"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_236_26657",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(237.911 242.405) rotate(-0.269977) scale(3.36533 3.26732)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7B799"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#F0D3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F8EBE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FDF9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_236_26657",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(251.717 242.29) rotate(-0.279976) scale(3.36533 3.26732)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7B799"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#F0D3C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F8EBE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FDF9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_236_26657",
    x1: 237.18,
    y1: 244.882,
    x2: 237.181,
    y2: 241.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8725D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#D46F5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#AA4F3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#913B2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#883424"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_236_26657",
    x1: 251.571,
    y1: 244.814,
    x2: 251.571,
    y2: 241.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8725D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#D46F5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#AA4F3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#913B2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#883424"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_236_26657",
    x1: 241.022,
    y1: 237.951,
    x2: 232.405,
    y2: 237.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE3C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#D63746"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C12B34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#AE2024"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_236_26657",
    x1: 247.513,
    y1: 237.92,
    x2: 256.13,
    y2: 237.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE3C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#D63746"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#C12B34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#AE2024"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_236_26657",
    x1: 244.623,
    y1: 239.276,
    x2: 244.685,
    y2: 251.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA6D40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#F58753"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F38350"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#EE7947"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#E66839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#E25F32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_236_26657",
    x1: 234.895,
    y1: 246.166,
    x2: 254.642,
    y2: 211.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#E84E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#E24A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#CB3C45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#BC3339"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#B83135"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_236_26657",
    x1: 57.8006,
    y1: 233.886,
    x2: 57.8006,
    y2: 144.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D46839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#C75526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#BD4516"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_236_26657",
    x1: 58.2342,
    y1: 195.735,
    x2: 58.2342,
    y2: 236.124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#F49281"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#F49483"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F9AA97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FBB39F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_236_26657",
    x1: 58.5272,
    y1: 160.823,
    x2: 58.5406,
    y2: 210.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F49281"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F59A88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#FAB19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB39F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_236_26657",
    x1: 39.6153,
    y1: 183.808,
    x2: 39.6153,
    y2: 195.292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F29F8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8A796"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial_236_26657",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-36.5657 257.589) rotate(138.49) scale(2.23977 2.95122)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C87B71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#D48478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E69385"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F29C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F69F8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_236_26657",
    x1: 41.491,
    y1: 189.436,
    x2: 39.9053,
    y2: 189.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6A393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#F8A596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FCAB9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_236_26657",
    x1: 77.2862,
    y1: 183.809,
    x2: 77.2827,
    y2: 195.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F29F8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8A796"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint77_radial_236_26657",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.3535 184.841) rotate(45.5801) scale(2.23977 2.95123)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C87B71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#D48478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E69385"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#F29C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F69F8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_236_26657",
    x1: 86.2218,
    y1: 195.476,
    x2: 87.8204,
    y2: 195.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6A393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#F7A596"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FCAB9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_236_26657",
    x1: 53.7814,
    y1: 177.575,
    x2: 43.4848,
    y2: 177.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D46839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#C75526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#BD4516"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_236_26657",
    x1: 63.4976,
    y1: 177.575,
    x2: 73.7909,
    y2: 177.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D46839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#C75526"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#BD4516"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_radial_236_26657",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.2869 191.73) rotate(180) scale(6.50083 6.50028)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E64C6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#AB3851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#62202F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#2D0E15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#0C0405"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint82_radial_236_26657",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.5197 -7.47781) rotate(-180) scale(6.50083 6.50028)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E64C6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#AB3851"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#62202F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#2D0E15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#0C0405"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_236_26657",
    x1: 58.6306,
    y1: 178.565,
    x2: 58.6306,
    y2: 195.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#FA9989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FAAA98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FBB39F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F49281"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint84_radial_236_26657",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.5985 183.335) scale(3.77575 3.77576)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9AAD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#E3C0DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F2E2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FBF7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_236_26657",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.9539 -7.49404) scale(3.77575 3.77576)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9AAD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#E3C0DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F2E2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FBF7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_236_26657",
    x1: 70.3264,
    y1: 186.991,
    x2: 70.3257,
    y2: 182.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6381C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#4B6699"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#39527A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#2E4567"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A4161"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_236_26657",
    x1: 52.2167,
    y1: 186.993,
    x2: 52.216,
    y2: 182.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6381C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#4B6699"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#39527A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#2E4567"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A4161"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_236_26657",
    x1: 241.099,
    y1: 56.2249,
    x2: 241.099,
    y2: 102.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB6436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#F27645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F98653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FD8F5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF935F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_236_26657",
    x1: 240.647,
    y1: 71.1397,
    x2: 240.647,
    y2: 15.9726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF935F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FB8A57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#EF6E3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_236_26657",
    x1: 226.314,
    y1: 47.2159,
    x2: 220.275,
    y2: 50.1392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F47C4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#F47D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#F58154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7875D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint91_radial_236_26657",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(152.49 107.737) rotate(139.92) scale(2.32752 3.06685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3592F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#CF6135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E16F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#ED7746"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F17A49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_236_26657",
    x1: 229.527,
    y1: 46.9965,
    x2: 227.801,
    y2: 46.5628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F47C4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F47E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F68459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F7875D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_236_26657",
    x1: 256.049,
    y1: 47.3024,
    x2: 262.085,
    y2: 50.2299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F47C4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#F47D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#F58154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7875D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_radial_236_26657",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(304.091 87.0681) rotate(40.16) scale(2.33022 3.07041)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3592F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#CF6135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E16F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#ED7746"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F17A49"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_236_26657",
    x1: 255.284,
    y1: 48.2986,
    x2: 256.993,
    y2: 47.8791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F47C4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F47E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F68459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F7875D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint96_radial_236_26657",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(233.677 42.2233) scale(3.99177 3.8755)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3B293"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#EED2C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#F7EAE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FDF9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint97_radial_236_26657",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(250.005 -7.3704) scale(3.99176 3.8755)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3B293"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#EED2C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#F7EAE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#FDF9F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_236_26657",
    x1: 233.056,
    y1: 45.9692,
    x2: 233.057,
    y2: 41.6958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#859A65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#738B56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#607B48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_236_26657",
    x1: 250.127,
    y1: 45.9714,
    x2: 250.128,
    y2: 41.6948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#859A65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#738B56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#607B48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_236_26657",
    x1: 237.633,
    y1: 38.2266,
    x2: 227.414,
    y2: 38.2266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#D57E56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#D27C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B86746"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#A3563B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#954A33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#8C442E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A422D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_236_26657",
    x1: 245.337,
    y1: 38.2266,
    x2: 255.556,
    y2: 38.2266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#D57E56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#D27C54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#B86746"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#A3563B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#954A33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#8C442E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A422D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_236_26657",
    x1: 241.899,
    y1: 39.8186,
    x2: 241.899,
    y2: 54.8936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F37245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FF8E58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FD8A55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#F8804D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#F06F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#EB6436"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_236_26657",
    x1: 242.674,
    y1: 50.2522,
    x2: 242.674,
    y2: 52.8316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#939393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#AAAAAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_236_26657",
    x1: 241.001,
    y1: 42.9902,
    x2: 241.001,
    y2: 73.4516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C87553"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#BD6C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#924A35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_236_26657",
    x1: 236.239,
    y1: 64.536,
    x2: 236.531,
    y2: 5.11572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#C87553"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#BD6C4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#924A35"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.1eee99169f583a78afafb8bc43bcc246.svg";
export { ForwardRef as ReactComponent };